import * as rr from "react";
import le, { forwardRef as z, useLayoutEffect as Li, useEffect as ee, useMemo as U, createContext as Dt, useContext as me, useCallback as W, useId as Di, useState as G, useRef as Y, createElement as gn } from "react";
import { Content as Fi, Item as ji, Root as Ii, Trigger as Ni } from "@radix-ui/react-accordion";
import { OpenInNewIcon as hn } from "@sbab-ui/icons";
import { Slot as _n } from "@radix-ui/react-slot";
import { Root as Ri, Trigger as Mi, Content as Vi } from "@radix-ui/react-collapsible";
var nr = { exports: {} }, tt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jr;
function Oi() {
  if (jr)
    return tt;
  jr = 1;
  var e = le, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(u, c, f) {
    var v, m = {}, p = null, y = null;
    f !== void 0 && (p = "" + f), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (v in c)
      n.call(c, v) && !i.hasOwnProperty(v) && (m[v] = c[v]);
    if (u && u.defaultProps)
      for (v in c = u.defaultProps, c)
        m[v] === void 0 && (m[v] = c[v]);
    return { $$typeof: t, type: u, key: p, ref: y, props: m, _owner: a.current };
  }
  return tt.Fragment = r, tt.jsx = o, tt.jsxs = o, tt;
}
var rt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ir;
function Ai() {
  return Ir || (Ir = 1, process.env.NODE_ENV !== "production" && function() {
    var e = le, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function k(l) {
      if (l === null || typeof l != "object")
        return null;
      var g = C && l[C] || l[S];
      return typeof g == "function" ? g : null;
    }
    var D = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function P(l) {
      {
        for (var g = arguments.length, E = new Array(g > 1 ? g - 1 : 0), N = 1; N < g; N++)
          E[N - 1] = arguments[N];
        T("error", l, E);
      }
    }
    function T(l, g, E) {
      {
        var N = D.ReactDebugCurrentFrame, B = N.getStackAddendum();
        B !== "" && (g += "%s", E = E.concat([B]));
        var K = E.map(function(A) {
          return String(A);
        });
        K.unshift("Warning: " + g), Function.prototype.apply.call(console[l], console, K);
      }
    }
    var h = !1, w = !1, M = !1, j = !1, s = !1, L;
    L = Symbol.for("react.module.reference");
    function $(l) {
      return !!(typeof l == "string" || typeof l == "function" || l === n || l === i || s || l === a || l === f || l === v || j || l === y || h || w || M || typeof l == "object" && l !== null && (l.$$typeof === p || l.$$typeof === m || l.$$typeof === o || l.$$typeof === u || l.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      l.$$typeof === L || l.getModuleId !== void 0));
    }
    function x(l, g, E) {
      var N = l.displayName;
      if (N)
        return N;
      var B = g.displayName || g.name || "";
      return B !== "" ? E + "(" + B + ")" : E;
    }
    function I(l) {
      return l.displayName || "Context";
    }
    function b(l) {
      if (l == null)
        return null;
      if (typeof l.tag == "number" && P("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof l == "function")
        return l.displayName || l.name || null;
      if (typeof l == "string")
        return l;
      switch (l) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case f:
          return "Suspense";
        case v:
          return "SuspenseList";
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case u:
            var g = l;
            return I(g) + ".Consumer";
          case o:
            var E = l;
            return I(E._context) + ".Provider";
          case c:
            return x(l, l.render, "ForwardRef");
          case m:
            var N = l.displayName || null;
            return N !== null ? N : b(l.type) || "Memo";
          case p: {
            var B = l, K = B._payload, A = B._init;
            try {
              return b(A(K));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var _ = Object.assign, V = 0, Z, oe, te, ae, fe, se, O;
    function pe() {
    }
    pe.__reactDisabledLog = !0;
    function ce() {
      {
        if (V === 0) {
          Z = console.log, oe = console.info, te = console.warn, ae = console.error, fe = console.group, se = console.groupCollapsed, O = console.groupEnd;
          var l = {
            configurable: !0,
            enumerable: !0,
            value: pe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: l,
            log: l,
            warn: l,
            error: l,
            group: l,
            groupCollapsed: l,
            groupEnd: l
          });
        }
        V++;
      }
    }
    function ue() {
      {
        if (V--, V === 0) {
          var l = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: _({}, l, {
              value: Z
            }),
            info: _({}, l, {
              value: oe
            }),
            warn: _({}, l, {
              value: te
            }),
            error: _({}, l, {
              value: ae
            }),
            group: _({}, l, {
              value: fe
            }),
            groupCollapsed: _({}, l, {
              value: se
            }),
            groupEnd: _({}, l, {
              value: O
            })
          });
        }
        V < 0 && P("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ve = D.ReactCurrentDispatcher, Pe;
    function Je(l, g, E) {
      {
        if (Pe === void 0)
          try {
            throw Error();
          } catch (B) {
            var N = B.stack.trim().match(/\n( *(at )?)/);
            Pe = N && N[1] || "";
          }
        return `
` + Pe + l;
      }
    }
    var Ve = !1, ke;
    {
      var Le = typeof WeakMap == "function" ? WeakMap : Map;
      ke = new Le();
    }
    function dt(l, g) {
      if (!l || Ve)
        return "";
      {
        var E = ke.get(l);
        if (E !== void 0)
          return E;
      }
      var N;
      Ve = !0;
      var B = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var K;
      K = ve.current, ve.current = null, ce();
      try {
        if (g) {
          var A = function() {
            throw Error();
          };
          if (Object.defineProperty(A.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(A, []);
            } catch (ge) {
              N = ge;
            }
            Reflect.construct(l, [], A);
          } else {
            try {
              A.call();
            } catch (ge) {
              N = ge;
            }
            l.call(A.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ge) {
            N = ge;
          }
          l();
        }
      } catch (ge) {
        if (ge && N && typeof ge.stack == "string") {
          for (var R = ge.stack.split(`
`), re = N.stack.split(`
`), H = R.length - 1, q = re.length - 1; H >= 1 && q >= 0 && R[H] !== re[q]; )
            q--;
          for (; H >= 1 && q >= 0; H--, q--)
            if (R[H] !== re[q]) {
              if (H !== 1 || q !== 1)
                do
                  if (H--, q--, q < 0 || R[H] !== re[q]) {
                    var de = `
` + R[H].replace(" at new ", " at ");
                    return l.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", l.displayName)), typeof l == "function" && ke.set(l, de), de;
                  }
                while (H >= 1 && q >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, ve.current = K, ue(), Error.prepareStackTrace = B;
      }
      var Ke = l ? l.displayName || l.name : "", Fr = Ke ? Je(Ke) : "";
      return typeof l == "function" && ke.set(l, Fr), Fr;
    }
    function Rt(l, g, E) {
      return dt(l, !1);
    }
    function ft(l) {
      var g = l.prototype;
      return !!(g && g.isReactComponent);
    }
    function De(l, g, E) {
      if (l == null)
        return "";
      if (typeof l == "function")
        return dt(l, ft(l));
      if (typeof l == "string")
        return Je(l);
      switch (l) {
        case f:
          return Je("Suspense");
        case v:
          return Je("SuspenseList");
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case c:
            return Rt(l.render);
          case m:
            return De(l.type, g, E);
          case p: {
            var N = l, B = N._payload, K = N._init;
            try {
              return De(K(B), g, E);
            } catch {
            }
          }
        }
      return "";
    }
    var Oe = Object.prototype.hasOwnProperty, pt = {}, Xe = D.ReactDebugCurrentFrame;
    function Ae(l) {
      if (l) {
        var g = l._owner, E = De(l.type, l._source, g ? g.type : null);
        Xe.setExtraStackFrame(E);
      } else
        Xe.setExtraStackFrame(null);
    }
    function Mt(l, g, E, N, B) {
      {
        var K = Function.call.bind(Oe);
        for (var A in l)
          if (K(l, A)) {
            var R = void 0;
            try {
              if (typeof l[A] != "function") {
                var re = Error((N || "React class") + ": " + E + " type `" + A + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[A] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              R = l[A](g, A, N, E, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              R = H;
            }
            R && !(R instanceof Error) && (Ae(B), P("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", N || "React class", E, A, typeof R), Ae(null)), R instanceof Error && !(R.message in pt) && (pt[R.message] = !0, Ae(B), P("Failed %s type: %s", E, R.message), Ae(null));
          }
      }
    }
    var Vt = Array.isArray;
    function Be(l) {
      return Vt(l);
    }
    function bt(l) {
      {
        var g = typeof Symbol == "function" && Symbol.toStringTag, E = g && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return E;
      }
    }
    function Qe(l) {
      try {
        return be(l), !1;
      } catch {
        return !0;
      }
    }
    function be(l) {
      return "" + l;
    }
    function et(l) {
      if (Qe(l))
        return P("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", bt(l)), be(l);
    }
    var we = D.ReactCurrentOwner, Ot = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, mt, J, At;
    At = {};
    function mi(l) {
      if (Oe.call(l, "ref")) {
        var g = Object.getOwnPropertyDescriptor(l, "ref").get;
        if (g && g.isReactWarning)
          return !1;
      }
      return l.ref !== void 0;
    }
    function vi(l) {
      if (Oe.call(l, "key")) {
        var g = Object.getOwnPropertyDescriptor(l, "key").get;
        if (g && g.isReactWarning)
          return !1;
      }
      return l.key !== void 0;
    }
    function gi(l, g) {
      if (typeof l.ref == "string" && we.current && g && we.current.stateNode !== g) {
        var E = b(we.current.type);
        At[E] || (P('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', b(we.current.type), l.ref), At[E] = !0);
      }
    }
    function hi(l, g) {
      {
        var E = function() {
          mt || (mt = !0, P("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", g));
        };
        E.isReactWarning = !0, Object.defineProperty(l, "key", {
          get: E,
          configurable: !0
        });
      }
    }
    function _i(l, g) {
      {
        var E = function() {
          J || (J = !0, P("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", g));
        };
        E.isReactWarning = !0, Object.defineProperty(l, "ref", {
          get: E,
          configurable: !0
        });
      }
    }
    var $i = function(l, g, E, N, B, K, A) {
      var R = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: l,
        key: g,
        ref: E,
        props: A,
        // Record the component responsible for creating this element.
        _owner: K
      };
      return R._store = {}, Object.defineProperty(R._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(R, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: N
      }), Object.defineProperty(R, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: B
      }), Object.freeze && (Object.freeze(R.props), Object.freeze(R)), R;
    };
    function yi(l, g, E, N, B) {
      {
        var K, A = {}, R = null, re = null;
        E !== void 0 && (et(E), R = "" + E), vi(g) && (et(g.key), R = "" + g.key), mi(g) && (re = g.ref, gi(g, B));
        for (K in g)
          Oe.call(g, K) && !Ot.hasOwnProperty(K) && (A[K] = g[K]);
        if (l && l.defaultProps) {
          var H = l.defaultProps;
          for (K in H)
            A[K] === void 0 && (A[K] = H[K]);
        }
        if (R || re) {
          var q = typeof l == "function" ? l.displayName || l.name || "Unknown" : l;
          R && hi(A, q), re && _i(A, q);
        }
        return $i(l, R, re, B, N, we.current, A);
      }
    }
    var Bt = D.ReactCurrentOwner, Sr = D.ReactDebugCurrentFrame;
    function ze(l) {
      if (l) {
        var g = l._owner, E = De(l.type, l._source, g ? g.type : null);
        Sr.setExtraStackFrame(E);
      } else
        Sr.setExtraStackFrame(null);
    }
    var zt;
    zt = !1;
    function Kt(l) {
      return typeof l == "object" && l !== null && l.$$typeof === t;
    }
    function Tr() {
      {
        if (Bt.current) {
          var l = b(Bt.current.type);
          if (l)
            return `

Check the render method of \`` + l + "`.";
        }
        return "";
      }
    }
    function xi(l) {
      {
        if (l !== void 0) {
          var g = l.fileName.replace(/^.*[\\\/]/, ""), E = l.lineNumber;
          return `

Check your code at ` + g + ":" + E + ".";
        }
        return "";
      }
    }
    var Cr = {};
    function Pi(l) {
      {
        var g = Tr();
        if (!g) {
          var E = typeof l == "string" ? l : l.displayName || l.name;
          E && (g = `

Check the top-level render call using <` + E + ">.");
        }
        return g;
      }
    }
    function kr(l, g) {
      {
        if (!l._store || l._store.validated || l.key != null)
          return;
        l._store.validated = !0;
        var E = Pi(g);
        if (Cr[E])
          return;
        Cr[E] = !0;
        var N = "";
        l && l._owner && l._owner !== Bt.current && (N = " It was passed a child from " + b(l._owner.type) + "."), ze(l), P('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', E, N), ze(null);
      }
    }
    function Lr(l, g) {
      {
        if (typeof l != "object")
          return;
        if (Be(l))
          for (var E = 0; E < l.length; E++) {
            var N = l[E];
            Kt(N) && kr(N, g);
          }
        else if (Kt(l))
          l._store && (l._store.validated = !0);
        else if (l) {
          var B = k(l);
          if (typeof B == "function" && B !== l.entries)
            for (var K = B.call(l), A; !(A = K.next()).done; )
              Kt(A.value) && kr(A.value, g);
        }
      }
    }
    function wi(l) {
      {
        var g = l.type;
        if (g == null || typeof g == "string")
          return;
        var E;
        if (typeof g == "function")
          E = g.propTypes;
        else if (typeof g == "object" && (g.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        g.$$typeof === m))
          E = g.propTypes;
        else
          return;
        if (E) {
          var N = b(g);
          Mt(E, l.props, "prop", N, l);
        } else if (g.PropTypes !== void 0 && !zt) {
          zt = !0;
          var B = b(g);
          P("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", B || "Unknown");
        }
        typeof g.getDefaultProps == "function" && !g.getDefaultProps.isReactClassApproved && P("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ei(l) {
      {
        for (var g = Object.keys(l.props), E = 0; E < g.length; E++) {
          var N = g[E];
          if (N !== "children" && N !== "key") {
            ze(l), P("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", N), ze(null);
            break;
          }
        }
        l.ref !== null && (ze(l), P("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    function Dr(l, g, E, N, B, K) {
      {
        var A = $(l);
        if (!A) {
          var R = "";
          (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (R += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = xi(B);
          re ? R += re : R += Tr();
          var H;
          l === null ? H = "null" : Be(l) ? H = "array" : l !== void 0 && l.$$typeof === t ? (H = "<" + (b(l.type) || "Unknown") + " />", R = " Did you accidentally export a JSX literal instead of a component?") : H = typeof l, P("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, R);
        }
        var q = yi(l, g, E, B, K);
        if (q == null)
          return q;
        if (A) {
          var de = g.children;
          if (de !== void 0)
            if (N)
              if (Be(de)) {
                for (var Ke = 0; Ke < de.length; Ke++)
                  Lr(de[Ke], l);
                Object.freeze && Object.freeze(de);
              } else
                P("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Lr(de, l);
        }
        return l === n ? Ei(q) : wi(q), q;
      }
    }
    function Si(l, g, E) {
      return Dr(l, g, E, !0);
    }
    function Ti(l, g, E) {
      return Dr(l, g, E, !1);
    }
    var Ci = Ti, ki = Si;
    rt.Fragment = n, rt.jsx = Ci, rt.jsxs = ki;
  }()), rt;
}
process.env.NODE_ENV === "production" ? nr.exports = Oi() : nr.exports = Ai();
var d = nr.exports;
function Bi() {
  let e = 0, t, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r && (r += " "), r += t);
  return r;
}
const F = Bi, zi = "_AccordionItem_fwao5_5", Ki = "_AccordionTrigger_fwao5_23", Ui = "_AccordionContent_fwao5_68", Wi = "_slideDown_fwao5_1", Hi = "_slideUp_fwao5_1", qi = "_AccordionContentContainer_fwao5_80", Et = {
  AccordionItem: zi,
  AccordionTrigger: Ki,
  AccordionContent: Ui,
  slideDown: Wi,
  slideUp: Hi,
  AccordionContentContainer: qi
};
function Yi({ children: e, className: t, ...r }, n) {
  return /* @__PURE__ */ d.jsx(
    Fi,
    {
      ...r,
      className: F(Et.AccordionContent, t),
      ref: n,
      children: /* @__PURE__ */ d.jsx("div", { className: Et.AccordionContentContainer, children: e })
    }
  );
}
const Gi = /* @__PURE__ */ z(
  Yi
);
function Zi() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
const Ji = Zi() ? Li : ee;
let Ut = !1, Xi = 0;
function Nr() {
  return ++Xi;
}
const Rr = rr["useId".toString()];
function Qi(e) {
  if (Rr !== void 0) {
    let a = Rr();
    return e ?? a;
  }
  let t = e ?? (Ut ? Nr() : null), [r, n] = rr.useState(t);
  return Ji(() => {
    r === null && n(Nr());
  }, []), rr.useEffect(() => {
    Ut === !1 && (Ut = !0);
  }, []), e ?? r ?? void 0;
}
function Ce() {
  return Qi();
}
function el({ className: e, ...t }, r) {
  const n = Ce();
  return /* @__PURE__ */ d.jsx(
    ji,
    {
      ...t,
      className: F(Et.AccordionItem, e),
      value: `${n}-value`,
      ref: r
    }
  );
}
const tl = /* @__PURE__ */ z(
  el
);
function rl({ children: e, ...t }, r) {
  return /* @__PURE__ */ d.jsx(Ii, { ...t, ref: r, type: "multiple", children: e });
}
const nl = /* @__PURE__ */ z(
  rl
);
function al({ children: e, className: t, ...r }, n) {
  return /* @__PURE__ */ d.jsxs(
    Ni,
    {
      ...r,
      className: F(Et.AccordionTrigger, t),
      ref: n,
      children: [
        e,
        /* @__PURE__ */ d.jsxs("svg", { viewBox: "0 0 24 24", width: "24", height: "24", "aria-hidden": !0, children: [
          /* @__PURE__ */ d.jsx("rect", { x: "3", y: "10.5", width: "18", height: "3" }),
          /* @__PURE__ */ d.jsx("rect", { x: "10.5", y: "3", width: "3", height: "18" })
        ] })
      ]
    }
  );
}
const il = /* @__PURE__ */ z(
  al
), su = {
  Content: Gi,
  Root: nl,
  Trigger: il,
  Item: tl
}, ll = "_spinner_9iv0a_1", ol = "_spin_9iv0a_1", sl = "_spinner__inner_9iv0a_15", cl = "_dash_9iv0a_1", Wt = {
  spinner: ll,
  spin: ol,
  "spinner--small": "_spinner--small_9iv0a_5",
  "spinner--large": "_spinner--large_9iv0a_8",
  "spinner--fill": "_spinner--fill_9iv0a_11",
  spinner__inner: sl,
  dash: cl
};
function ul({ className: e, color: t, innerRef: r, size: n, ...a }, i) {
  return /* @__PURE__ */ d.jsx(
    "svg",
    {
      ...a,
      viewBox: "0 0 24 24",
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      className: F(
        Wt.spinner,
        n && Wt[`spinner--${n}`],
        e
      ),
      ref: i ?? r,
      children: /* @__PURE__ */ d.jsx(
        "circle",
        {
          className: Wt.spinner__inner,
          cx: "12",
          cy: "12",
          r: "10",
          style: t ? { stroke: t } : void 0
        }
      )
    }
  );
}
const dl = /* @__PURE__ */ z(ul), fl = "_button_c0jdr_5", pl = "_button__spinner_c0jdr_69", bl = "_button__children_c0jdr_99", ml = "_disappear_c0jdr_1", vl = "_appear_c0jdr_1", Te = {
  button: fl,
  "button--disabled": "_button--disabled_c0jdr_26",
  "button--large": "_button--large_c0jdr_42",
  "button--small": "_button--small_c0jdr_48",
  "button--x-small": "_button--x-small_c0jdr_53",
  "button--primary": "_button--primary_c0jdr_59",
  button__spinner: pl,
  "button--secondary": "_button--secondary_c0jdr_72",
  "button--danger": "_button--danger_c0jdr_83",
  "button--loading": "_button--loading_c0jdr_96",
  button__children: bl,
  disappear: ml,
  appear: vl
};
function $n(e, t, r, n) {
  return U(
    () => F(
      Te.button,
      e && Te[`button--${e}`],
      r && Te[`button--${r}`],
      t && Te[`button--${t}`],
      n
    ),
    [e, t, r, n]
  );
}
function gl({
  children: e,
  className: t,
  disabled: r,
  innerRef: n,
  intent: a,
  loading: i,
  size: o,
  variant: u,
  ...c
}, f) {
  const v = $n(a, o, u, t);
  return /* @__PURE__ */ d.jsxs(
    "button",
    {
      type: "button",
      ...c,
      disabled: i || r,
      className: F(
        i && Te["button--loading"],
        r && Te["button--disabled"],
        v
      ),
      ref: f ?? n,
      children: [
        /* @__PURE__ */ d.jsx("span", { className: Te.button__children, children: e }),
        i && /* @__PURE__ */ d.jsx("span", { className: Te.button__spinner, children: /* @__PURE__ */ d.jsx(dl, { color: "currentColor", size: "fill" }) })
      ]
    }
  );
}
const cu = /* @__PURE__ */ z(gl), hl = "_link_eeesw_1", _l = "_link__icon_eeesw_13", Mr = {
  link: hl,
  link__icon: _l
};
function yn(e, t, r) {
  return e && (r = "_blank"), r === "_blank" && !t && (t = "noreferrer noopener"), { rel: t, target: r };
}
function $l({ children: e, className: t, external: r, innerRef: n, rel: a, target: i, ...o }, u) {
  return { rel: a, target: i } = yn(r, a, i), /* @__PURE__ */ d.jsxs(
    "a",
    {
      ...o,
      ref: u ?? n,
      className: F(Mr.link, t),
      rel: a,
      target: i,
      children: [
        e,
        i === "_blank" && /* @__PURE__ */ d.jsx(hn, { className: F(Mr.link__icon) })
      ]
    }
  );
}
const uu = /* @__PURE__ */ z($l), Vr = {
  "button-link": "_button-link_1s0b3_1",
  "button-link__icon": "_button-link__icon_1s0b3_4"
};
function yl({
  innerRef: e,
  children: t,
  className: r,
  external: n,
  intent: a,
  rel: i,
  size: o,
  variant: u,
  target: c,
  ...f
}, v) {
  const m = $n(
    a,
    o,
    u,
    F(Vr["button-link"], r)
  );
  return { rel: i, target: c } = yn(n, i, c), /* @__PURE__ */ d.jsxs(
    "a",
    {
      ...f,
      ref: v ?? e,
      className: m,
      rel: i,
      target: c,
      children: [
        t,
        c === "_blank" && /* @__PURE__ */ d.jsx(hn, { className: F(Vr["button-link__icon"]) })
      ]
    }
  );
}
const du = /* @__PURE__ */ z(
  yl
), xl = "_callout_1v9gl_5", Pl = "_callout__header_1v9gl_23", wl = "_callout__icon_1v9gl_36", El = "_callout__title_1v9gl_52", Sl = "_callout__content_1v9gl_63", he = {
  callout: xl,
  "callout--attention": "_callout--attention_1v9gl_12",
  "callout--informative": "_callout--informative_1v9gl_15",
  callout__header: Pl,
  "callout__header--informative": "_callout__header--informative_1v9gl_29",
  callout__icon: wl,
  "callout__icon--attention": "_callout__icon--attention_1v9gl_42",
  "callout__icon--informative": "_callout__icon--informative_1v9gl_45",
  callout__title: El,
  "callout__title--informative": "_callout__title--informative_1v9gl_59",
  callout__content: Sl
};
function Tl({ className: e }) {
  return /* @__PURE__ */ d.jsx(
    "svg",
    {
      className: e,
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": !0,
      children: /* @__PURE__ */ d.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M27.6489 48.3288H37.5713V28.9146H27.6489V48.3288ZM31.9337 14.9278C35.0251 14.9278 37.5308 17.4292 37.5308 20.5148C37.5308 23.6005 35.0251 26.102 31.9337 26.102C28.8432 26.102 26.3372 23.6005 26.3372 20.5148C26.3372 17.4292 28.8432 14.9278 31.9337 14.9278V14.9278ZM51.259 5L11.75 5.73228L12.7414 59L52.2502 58.2671L51.259 5Z",
          fill: "#FF620F"
        }
      )
    }
  );
}
function Cl({
  children: e,
  className: t,
  innerRef: r,
  intent: n,
  title: a,
  variant: i,
  ...o
}, u) {
  const c = i || n, f = `callout-title-${Ce()}`;
  return /* @__PURE__ */ d.jsxs(
    "aside",
    {
      "aria-labelledby": f,
      className: F(
        he.callout,
        c && he[`callout--${c}`],
        t
      ),
      ref: u ?? r,
      ...o,
      children: [
        /* @__PURE__ */ d.jsxs(
          "div",
          {
            className: F(
              he.callout__header,
              c && he[`callout__header--${c}`]
            ),
            children: [
              /* @__PURE__ */ d.jsx(
                Tl,
                {
                  className: F(
                    he.callout__icon,
                    c && he[`callout__icon--${c}`]
                  )
                }
              ),
              /* @__PURE__ */ d.jsx(
                "p",
                {
                  className: F(
                    he.callout__title,
                    c && he[`callout__title--${c}`]
                  ),
                  id: f,
                  children: a
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ d.jsx("div", { className: he.callout__content, children: e })
      ]
    }
  );
}
const fu = /* @__PURE__ */ z(Cl), kl = "_callout_olsir_1", Ll = "_callout__content_olsir_19", Ht = {
  callout: kl,
  "callout--success": "_callout--success_olsir_10",
  "callout--danger": "_callout--danger_olsir_14",
  callout__content: Ll
};
function pu({
  children: e,
  className: t,
  intent: r,
  variant: n,
  ...a
}) {
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      className: F(
        Ht.callout,
        Ht[`callout--${r ?? n}`],
        t
      ),
      ...a,
      children: /* @__PURE__ */ d.jsx("div", { className: Ht.callout__content, children: e })
    }
  );
}
const Dl = "_checkbox__input_1ofrx_1", Fl = "_checkbox__label_1ofrx_6", Or = {
  checkbox__input: Dl,
  checkbox__label: Fl
}, xn = Dt(null);
function jl({
  checked: e,
  className: t,
  defaultChecked: r,
  disabled: n = !1,
  id: a,
  innerRef: i,
  inputClassName: o,
  inputProps: u = {},
  inputRef: c,
  label: f,
  labelClassName: v,
  labelProps: m = {},
  labelRef: p,
  name: y,
  onBlur: C,
  onChange: S,
  onFocus: k,
  value: D,
  ...P
}, T) {
  var L;
  const h = me(xn), w = W(
    ($) => {
      S && S($), h != null && h.onChange && h.onChange($);
    },
    [S, h == null ? void 0 : h.onChange]
  ), M = `checkbox-${Ce()}`, j = a ?? M;
  let s = e;
  return h != null && h.values && (s = ((L = h.values) == null ? void 0 : L.indexOf(D)) > -1), /* @__PURE__ */ d.jsxs(
    "div",
    {
      ...P,
      ref: T ?? i,
      className: t,
      onClick: ($) => {
        $.target.localName === "input" && $.target.focus(), typeof P.onClick == "function" && P.onClick($);
      },
      children: [
        /* @__PURE__ */ d.jsx(
          "input",
          {
            ...u,
            checked: s,
            className: F(Or.checkbox__input, o),
            defaultChecked: r,
            disabled: n,
            id: j,
            name: y ?? (h == null ? void 0 : h.name),
            onBlur: C,
            onChange: w,
            onFocus: k,
            ref: c,
            type: "checkbox",
            value: D
          }
        ),
        /* @__PURE__ */ d.jsx(
          "label",
          {
            ...m,
            htmlFor: j,
            ref: p,
            className: F(Or.checkbox__label, v),
            children: f
          }
        )
      ]
    }
  );
}
const bu = /* @__PURE__ */ z(jl), Il = "_description_exv25_5", Nl = {
  description: Il
};
function Rl({ children: e, className: t, ...r }, n) {
  return /* @__PURE__ */ d.jsx("div", { ...r, ref: n, className: F(Nl.description, t), children: e });
}
const ct = /* @__PURE__ */ z(
  Rl
), Ml = "_label_1xgf1_5", Vl = "_label__secondary_1xgf1_16", qt = {
  label: Ml,
  "label--block": "_label--block_1xgf1_12",
  label__secondary: Vl
};
function Ol({
  block: e = !1,
  children: t,
  className: r,
  secondaryLabel: n,
  secondaryLabelClassName: a,
  secondaryLabelProps: i = {},
  secondaryLabelRef: o,
  innerRef: u,
  ...c
}, f) {
  return /* @__PURE__ */ d.jsxs(
    "label",
    {
      ...c,
      ref: f ?? u,
      className: F(qt.label, e && qt["label--block"], r),
      children: [
        t,
        /* @__PURE__ */ d.jsx(
          "span",
          {
            ...i,
            className: F(qt.label__secondary, a),
            ref: o,
            children: n
          }
        )
      ]
    }
  );
}
const Al = /* @__PURE__ */ z(
  Ol
), Bl = "_label_1xgf5_5", Ar = {
  label: Bl,
  "label--block": "_label--block_1xgf5_12"
};
function zl(e, t) {
  const {
    block: r = !1,
    children: n,
    className: a,
    secondaryLabel: i,
    innerRef: o,
    ...u
  } = e;
  return i ? /* @__PURE__ */ d.jsx(Al, { ...e, secondaryLabel: i }) : /* @__PURE__ */ d.jsx(
    "label",
    {
      ...u,
      ref: t ?? o,
      className: F(Ar.label, r && Ar["label--block"], a),
      children: n
    }
  );
}
const ut = /* @__PURE__ */ z(zl);
function Kl(e) {
  return /* @__PURE__ */ d.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      width: "24",
      height: "24",
      ...e,
      children: [
        /* @__PURE__ */ d.jsx("path", { d: "M0 0h24v24H0z", fill: "none" }),
        /* @__PURE__ */ d.jsx("path", { d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" })
      ]
    }
  );
}
function Ul(e) {
  return /* @__PURE__ */ d.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      width: "24",
      height: "24",
      ...e,
      children: [
        /* @__PURE__ */ d.jsx("path", { d: "M0 0h24v24H0z", fill: "none" }),
        /* @__PURE__ */ d.jsx("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" })
      ]
    }
  );
}
function Wl(e) {
  return /* @__PURE__ */ d.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      width: "24",
      height: "24",
      ...e,
      children: [
        /* @__PURE__ */ d.jsx("path", { d: "M0 0h24v24H0z", fill: "none" }),
        /* @__PURE__ */ d.jsx("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" })
      ]
    }
  );
}
const Hl = "_message_wmet9_1", ql = "_message__icon_wmet9_18", Ee = {
  message: Hl,
  "message--critical": "_message--critical_wmet9_8",
  "message--warning": "_message--warning_wmet9_11",
  "message--positive": "_message--positive_wmet9_14",
  message__icon: ql,
  "message__icon--critical": "_message__icon--critical_wmet9_24",
  "message__icon--warning": "_message__icon--warning_wmet9_27",
  "message__icon--positive": "_message__icon--positive_wmet9_30"
};
function Yl({ children: e, className: t, tone: r, innerRef: n, ...a }, i) {
  let o = null;
  return r === "critical" && (o = /* @__PURE__ */ d.jsx(
    Ul,
    {
      "aria-hidden": !0,
      className: F(
        Ee.message__icon,
        Ee["message__icon--critical"]
      )
    }
  )), r === "warning" && (o = /* @__PURE__ */ d.jsx(
    Kl,
    {
      "aria-hidden": !0,
      className: F(
        Ee.message__icon,
        Ee["message__icon--warning"]
      )
    }
  )), r === "positive" && (o = /* @__PURE__ */ d.jsx(
    Wl,
    {
      "aria-hidden": !0,
      className: F(
        Ee.message__icon,
        Ee["message__icon--positive"]
      )
    }
  )), /* @__PURE__ */ d.jsxs(
    "div",
    {
      ...a,
      ref: i ?? n,
      className: F(
        Ee.message,
        r && Ee[`message--${r}`],
        t
      ),
      children: [
        o,
        e
      ]
    }
  );
}
const Ft = /* @__PURE__ */ z(Yl), Br = {
  "checkbox-group--row": "_checkbox-group--row_e7s4j_1"
}, Gl = "_flex_rcwev_5", Zl = "_align_rcwev_9", Jl = "_direction_rcwev_13", Xl = "_gap_rcwev_17", Ql = "_grow_rcwev_21", eo = "_justify_rcwev_25", X = {
  flex: Gl,
  align: Zl,
  direction: Jl,
  gap: Xl,
  grow: Ql,
  justify: eo,
  "align-md": "_align-md_rcwev_30",
  "direction-md": "_direction-md_rcwev_33",
  "gap-md": "_gap-md_rcwev_36",
  "grow-md": "_grow-md_rcwev_39",
  "justify-md": "_justify-md_rcwev_42",
  "align-lg": "_align-lg_rcwev_47",
  "direction-lg": "_direction-lg_rcwev_50",
  "gap-lg": "_gap-lg_rcwev_53",
  "grow-lg": "_grow-lg_rcwev_56",
  "justify-lg": "_justify-lg_rcwev_59"
};
function to({
  asChild: e,
  align: t,
  "md-align": r,
  "lg-align": n,
  className: a,
  direction: i,
  "md-direction": o,
  "lg-direction": u,
  grow: c,
  "md-grow": f,
  "lg-grow": v,
  gap: m,
  "md-gap": p,
  "lg-gap": y,
  justify: C,
  "md-justify": S,
  "lg-justify": k,
  style: D,
  ...P
}, T) {
  const [h, w] = U(() => {
    const j = [X.flex];
    let s = {};
    return t && (j.push(X.align), s["--sbui-flex-align"] = t), r && (j.push(X["align-md"]), s["--sbui-flex-align-md"] = r), n && (j.push(X["align-lg"]), s["--sbui-flex-align-lg"] = n), i && (j.push(X.direction), s["--sbui-flex-direction"] = i), o && (j.push(X["direction-md"]), s["--sbui-flex-direction-md"] = o), u && (j.push(X["direction-lg"]), s["--sbui-flex-direction-lg"] = u), m && (j.push(X.gap), s["--sbui-flex-gap"] = m), p && (j.push(X["gap-md"]), s["--sbui-flex-gap-md"] = p), y && (j.push(X["gap-lg"]), s["--sbui-flex-gap-lg"] = y), typeof c == "boolean" && (j.push(X.grow), s["--sbui-flex-grow"] = c ? 1 : "initial"), typeof f == "boolean" && (j.push(X["grow-md"]), s["--sbui-flex-grow-md"] = f ? 1 : "initial"), typeof v == "boolean" && (j.push(X["grow-lg"]), s["--sbui-flex-grow-lg"] = v ? 1 : "initial"), C && (j.push(X.justify), s["--sbui-flex-justify"] = C), S && (j.push(X["justify-md"]), s["--sbui-flex-justify-md"] = S), k && (j.push(X["justify-lg"]), s["--sbui-flex-justify-lg"] = k), D && (s = {
      ...D,
      ...s
    }), [j.concat(a), s];
  }, [
    t,
    r,
    n,
    i,
    o,
    u,
    c,
    f,
    v,
    C,
    S,
    k,
    m,
    p,
    y,
    a,
    D
  ]), M = e ? _n : "div";
  return /* @__PURE__ */ d.jsx(M, { ...P, ref: T, className: F(...h), style: w });
}
const Ze = /* @__PURE__ */ z(to), ro = "_grid_gaepk_5", no = "_columns_gaepk_9", ao = "_gap_gaepk_13", ie = {
  grid: ro,
  columns: no,
  gap: ao,
  "gap-x": "_gap-x_gaepk_17",
  "gap-y": "_gap-y_gaepk_21",
  "columns-md": "_columns-md_gaepk_26",
  "gap-md": "_gap-md_gaepk_29",
  "gap-x-md": "_gap-x-md_gaepk_32",
  "gap-y-md": "_gap-y-md_gaepk_35",
  "columns-lg": "_columns-lg_gaepk_40",
  "gap-lg": "_gap-lg_gaepk_43",
  "gap-x-lg": "_gap-x-lg_gaepk_46",
  "gap-y-lg": "_gap-y-lg_gaepk_49"
};
function io({
  asChild: e,
  className: t,
  columns: r,
  "md-columns": n,
  "lg-columns": a,
  gap: i,
  "md-gap": o,
  "lg-gap": u,
  "gap-x": c,
  "md-gap-x": f,
  "lg-gap-x": v,
  "gap-y": m,
  "md-gap-y": p,
  "lg-gap-y": y,
  style: C,
  ...S
}, k) {
  const [D, P] = U(() => {
    const h = [ie.grid];
    let w = {};
    return r && (h.push(ie.columns), w["--sbui-grid-columns"] = r), n && (h.push(ie["columns-md"]), w["--sbui-grid-columns-md"] = n), a && (h.push(ie["columns-lg"]), w["--sbui-grid-columns-lg"] = a), i && (h.push(ie.gap), w["--sbui-grid-gap"] = i), o && (h.push(ie["gap-md"]), w["--sbui-grid-gap-md"] = o), u && (h.push(ie["gap-lg"]), w["--sbui-grid-gap-lg"] = u), c && (h.push(ie["gap-x"]), w["--sbui-grid-gap-x"] = c), f && (h.push(ie["gap-x-md"]), w["--sbui-grid-gap-x-md"] = f), v && (h.push(ie["gap-x-lg"]), w["--sbui-grid-gap-x-lg"] = v), m && (h.push(ie["gap-y"]), w["--sbui-grid-gap-y"] = m), p && (h.push(ie["gap-y-md"]), w["--sbui-grid-gap-y-md"] = p), y && (h.push(ie["gap-y-lg"]), w["--sbui-grid-gap-y-lg"] = y), C && (w = {
      ...C,
      ...w
    }), [h.concat(t), w];
  }, [
    t,
    r,
    n,
    a,
    i,
    o,
    u,
    c,
    f,
    v,
    m,
    p,
    y,
    C
  ]), T = e ? _n : "div";
  return /* @__PURE__ */ d.jsx(T, { ...S, ref: k, className: F(...D), style: P });
}
const mu = /* @__PURE__ */ z(io), lo = "_spacer_krim3_5", oo = "_hidden_krim3_9", Ue = {
  spacer: lo,
  hidden: oo,
  "hidden-md": "_hidden-md_krim3_14",
  "visible-md": "_visible-md_krim3_17",
  "hidden-lg": "_hidden-lg_krim3_22",
  "visible-lg": "_visible-lg_krim3_25"
};
function vu({
  className: e,
  hidden: t,
  "md-hidden": r,
  "lg-hidden": n,
  style: a
}) {
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      "aria-hidden": !0,
      className: F(
        Ue.spacer,
        t && Ue.hidden,
        r === !0 && Ue["hidden-md"],
        r === !1 && Ue["visible-md"],
        n === !0 && Ue["hidden-lg"],
        n === !1 && Ue["visible-lg"],
        e
      ),
      style: a
    }
  );
}
function gu({
  children: e,
  description: t,
  label: r,
  message: n,
  name: a,
  onChange: i,
  row: o,
  secondaryLabel: u,
  supplemental: c,
  tone: f,
  values: v = [],
  ...m
}) {
  const p = Ce(), y = `label-${p}`, C = `description-${p}`, S = `message-${p}`, k = W(
    (T) => {
      if (i) {
        const { value: h } = T.currentTarget, w = v.indexOf(h);
        w > -1 ? i(v.filter((M, j) => j !== w)) : i([...v, h]);
      }
    },
    [i, v]
  ), D = U(
    () => ({
      name: a,
      onChange: k,
      values: v ?? []
    }),
    [a, k, v]
  );
  let P;
  return (n || t) && (P = [t && C, n && S].filter(Boolean).join(" ")), /* @__PURE__ */ d.jsxs(Ze, { ...m, direction: "column", gap: "0.5rem", children: [
    r && /* @__PURE__ */ d.jsxs("div", { children: [
      /* @__PURE__ */ d.jsx(
        ut,
        {
          block: !0,
          id: y,
          secondaryLabel: t ? void 0 : u,
          children: r
        }
      ),
      typeof t < "u" && /* @__PURE__ */ d.jsx(ct, { id: C, children: t })
    ] }),
    c,
    /* @__PURE__ */ d.jsx(xn.Provider, { value: D, children: /* @__PURE__ */ d.jsx(
      "div",
      {
        role: "group",
        "aria-labelledby": y,
        "aria-describedby": P,
        "aria-invalid": f === "critical",
        className: F(
          Br["checkbox-group"],
          o && Br["checkbox-group--row"]
        ),
        children: e
      }
    ) }),
    n && /* @__PURE__ */ d.jsx(Ft, { id: S, tone: f, children: n })
  ] });
}
const Pn = Dt({
  triggerId: "changeme"
});
function wn() {
  return me(Pn);
}
function so(e, t) {
  const r = Di(), n = U(() => ({ triggerId: `${r}-trigger` }), [r]);
  return /* @__PURE__ */ d.jsx(Pn.Provider, { value: n, children: /* @__PURE__ */ d.jsx(Ri, { ...e, ref: t }) });
}
const co = /* @__PURE__ */ z(
  so
);
function uo(e, t) {
  const { triggerId: r } = wn();
  return /* @__PURE__ */ d.jsx(
    Mi,
    {
      ...e,
      id: e.id ?? r,
      ref: t
    }
  );
}
const fo = /* @__PURE__ */ z(
  uo
), po = "_animated_1f5b9_1", bo = "_slideDown_1f5b9_1", mo = "_slideUp_1f5b9_1", vo = {
  animated: po,
  slideDown: bo,
  slideUp: mo
};
function go({
  animated: e,
  className: t,
  labelled: r,
  region: n,
  style: a,
  ...i
}, o) {
  const { triggerId: u } = wn(), c = (r || n) && !i["aria-label"];
  return /* @__PURE__ */ d.jsx(
    Vi,
    {
      ref: o,
      className: F(e && vo.animated, t),
      "aria-labelledby": c ? u : void 0,
      role: n ? "region" : void 0,
      ...i,
      style: {
        "--sbui-collapsible-content-width": "var(--radix-collapsible-content-width)",
        "--sbui-collapsible-content-height": "var(--radix-collapsible-content-height)",
        ...a
      }
    }
  );
}
const ho = /* @__PURE__ */ z(
  go
), hu = {
  Root: co,
  Trigger: fo,
  Content: ho
}, _o = "_exclamationSpinner_hname_5", $o = "_exclamationSpinnerCircle_hname_9", yo = "_circle_animation_hname_1", xo = "_exclamationSpinnerRect_hname_16", Po = "_rect_animation_hname_1", Yt = {
  exclamationSpinner: _o,
  exclamationSpinnerCircle: $o,
  circle_animation: yo,
  exclamationSpinnerRect: xo,
  rect_animation: Po
};
function wo({ className: e, ...t }, r) {
  return /* @__PURE__ */ d.jsxs(
    "svg",
    {
      ...t,
      className: F(Yt.exclamationSpinner, e),
      viewBox: "100 100 300 300",
      xmlns: "http://www.w3.org/2000/svg",
      ref: r,
      children: [
        /* @__PURE__ */ d.jsx(
          "rect",
          {
            className: Yt.exclamationSpinnerRect,
            x: "220",
            y: "200",
            width: "50",
            height: "190"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "circle",
          {
            className: Yt.exclamationSpinnerCircle,
            cx: "245",
            cy: "140",
            r: "30"
          }
        )
      ]
    }
  );
}
const _u = /* @__PURE__ */ z(
  wo
), Eo = "_input_z3wyy_1", vt = {
  input: Eo,
  "input--block": "_input--block_z3wyy_32",
  "input--invalid": "_input--invalid_z3wyy_36",
  "input--large": "_input--large_z3wyy_39",
  "input--small": "_input--small_z3wyy_44"
};
function So({
  block: e = !1,
  className: t,
  invalid: r = !1,
  innerRef: n,
  type: a = "text",
  size: i,
  ...o
}, u) {
  return /* @__PURE__ */ d.jsx(
    "input",
    {
      ...o,
      "aria-invalid": r ? !0 : void 0,
      type: a,
      ref: u ?? n,
      className: F(
        vt.input,
        i && vt[`input--${i}`],
        e && vt["input--block"],
        r && vt["input--invalid"],
        t
      )
    }
  );
}
const To = /* @__PURE__ */ z(So), xt = {
  "input-group": "_input-group_1ebow_1",
  "input-group--block": "_input-group--block_1ebow_9",
  "input-group__label": "_input-group__label_1ebow_14",
  "input-group--disabled": "_input-group--disabled_1ebow_30"
};
function Co({
  block: e = !1,
  children: t,
  className: r,
  disabled: n = !1,
  ...a
}) {
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      className: F(
        xt["input-group"],
        n && xt["input-group--disabled"],
        e && xt["input-group--block"],
        r
      ),
      ...a,
      children: t
    }
  );
}
function zr({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      "aria-hidden": !0,
      ...t,
      className: F(xt["input-group__label"], e)
    }
  );
}
function br(e, t, r) {
  let [n, a] = G(e || t), i = Y(e !== void 0), o = e !== void 0;
  ee(() => {
    let f = i.current;
    f !== o && console.warn(`WARN: A component changed from ${f ? "controlled" : "uncontrolled"} to ${o ? "controlled" : "uncontrolled"}.`), i.current = o;
  }, [
    o
  ]);
  let u = o ? e : n, c = W((f, ...v) => {
    let m = (p, ...y) => {
      r && (Object.is(u, p) || r(p, ...y)), o || (u = p);
    };
    typeof f == "function" ? (console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), a((y, ...C) => {
      let S = f(o ? u : y, ...C);
      return m(S, ...v), o ? y : S;
    })) : (o || a(f), m(f, ...v));
  }, [
    o,
    u,
    r
  ]);
  return [
    u,
    c
  ];
}
function ko(e, t = -1 / 0, r = 1 / 0) {
  return Math.min(Math.max(e, t), r);
}
function Fe(e, t, r, n) {
  t = Number(t), r = Number(r);
  let a = (e - (isNaN(t) ? 0 : t)) % n, i = Math.abs(a) * 2 >= n ? e + Math.sign(a) * (n - Math.abs(a)) : e - a;
  isNaN(t) ? !isNaN(r) && i > r && (i = Math.floor(r / n) * n) : i < t ? i = t : !isNaN(r) && i > r && (i = t + Math.floor((r - t) / n) * n);
  let o = n.toString(), u = o.indexOf("."), c = u >= 0 ? o.length - u : 0;
  if (c > 0) {
    let f = Math.pow(10, c);
    i = Math.round(i * f) / f;
  }
  return i;
}
const En = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, Sn = {
  ...En,
  customError: !0,
  valid: !1
}, nt = {
  isInvalid: !1,
  validationDetails: En,
  validationErrors: []
}, Lo = Dt({}), ar = "__formValidationState" + Date.now();
function Tn(e) {
  if (e[ar]) {
    let { realtimeValidation: t, displayValidation: r, updateValidation: n, resetValidation: a, commitValidation: i } = e[ar];
    return {
      realtimeValidation: t,
      displayValidation: r,
      updateValidation: n,
      resetValidation: a,
      commitValidation: i
    };
  }
  return Do(e);
}
function Do(e) {
  let { isInvalid: t, validationState: r, name: n, value: a, builtinValidation: i, validate: o, validationBehavior: u = "aria" } = e;
  r && (t || (t = r === "invalid"));
  let c = t ? {
    isInvalid: !0,
    validationErrors: [],
    validationDetails: Sn
  } : null, f = U(() => Kr(Fo(o, a)), [
    o,
    a
  ]);
  i != null && i.validationDetails.valid && (i = null);
  let v = me(Lo), m = U(() => n ? Array.isArray(n) ? n.flatMap(($) => ir(v[$])) : ir(v[n]) : [], [
    v,
    n
  ]), [p, y] = G(v), [C, S] = G(!1);
  v !== p && (y(v), S(!1));
  let k = U(() => Kr(C ? [] : m), [
    C,
    m
  ]), D = Y(nt), [P, T] = G(nt), h = Y(nt), w = () => {
    if (!M)
      return;
    j(!1);
    let $ = f || i || D.current;
    Gt($, h.current) || (h.current = $, T($));
  }, [M, j] = G(!1);
  return ee(w), {
    realtimeValidation: c || k || f || i || nt,
    displayValidation: u === "native" ? c || k || P : c || k || f || i || P,
    updateValidation($) {
      u === "aria" && !Gt(P, $) ? T($) : D.current = $;
    },
    resetValidation() {
      let $ = nt;
      Gt($, h.current) || (h.current = $, T($)), u === "native" && j(!1), S(!0);
    },
    commitValidation() {
      u === "native" && j(!0), S(!0);
    }
  };
}
function ir(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function Fo(e, t) {
  if (typeof e == "function") {
    let r = e(t);
    if (r && typeof r != "boolean")
      return ir(r);
  }
  return [];
}
function Kr(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: Sn
  } : null;
}
function Gt(e, t) {
  return e === t ? !0 : e && t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((r, n) => r === t.validationErrors[n]) && Object.entries(e.validationDetails).every(([r, n]) => t.validationDetails[r] === n);
}
class jo {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(t, r) {
    let n = this.strings[r];
    n || (n = Io(r, this.strings, this.defaultLocale), this.strings[r] = n);
    let a = n[t];
    if (!a)
      throw new Error(`Could not find intl message ${t} in ${r} locale`);
    return a;
  }
  constructor(t, r = "en-US") {
    this.strings = {
      ...t
    }, this.defaultLocale = r;
  }
}
function Io(e, t, r = "en-US") {
  if (t[e])
    return t[e];
  let n = No(e);
  if (t[n])
    return t[n];
  for (let a in t)
    if (a.startsWith(n + "-"))
      return t[a];
  return t[r];
}
function No(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const Ur = /* @__PURE__ */ new Map(), Wr = /* @__PURE__ */ new Map();
class Ro {
  /** Formats a localized string for the given key with the provided variables. */
  format(t, r) {
    let n = this.strings.getStringForLocale(t, this.locale);
    return typeof n == "function" ? n(r, this) : n;
  }
  plural(t, r, n = "cardinal") {
    let a = r["=" + t];
    if (a)
      return typeof a == "function" ? a() : a;
    let i = this.locale + ":" + n, o = Ur.get(i);
    o || (o = new Intl.PluralRules(this.locale, {
      type: n
    }), Ur.set(i, o));
    let u = o.select(t);
    return a = r[u] || r.other, typeof a == "function" ? a() : a;
  }
  number(t) {
    let r = Wr.get(this.locale);
    return r || (r = new Intl.NumberFormat(this.locale), Wr.set(this.locale, r)), r.format(t);
  }
  select(t, r) {
    let n = t[r] || t.other;
    return typeof n == "function" ? n() : n;
  }
  constructor(t, r) {
    this.locale = t, this.strings = r;
  }
}
let Zt = /* @__PURE__ */ new Map(), lr = !1;
try {
  lr = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let St = !1;
try {
  St = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const Cn = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class Tt {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(t) {
    let r = "";
    if (!lr && this.options.signDisplay != null ? r = Vo(this.numberFormatter, this.options.signDisplay, t) : r = this.numberFormatter.format(t), this.options.style === "unit" && !St) {
      var n;
      let { unit: a, unitDisplay: i = "short", locale: o } = this.resolvedOptions(), u = (n = Cn[a]) === null || n === void 0 ? void 0 : n[i];
      r += u[o] || u.default;
    }
    return r;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(t) {
    return this.numberFormatter.formatToParts(t);
  }
  /** Formats a number range as a string. */
  formatRange(t, r) {
    if (typeof this.numberFormatter.formatRange == "function")
      return this.numberFormatter.formatRange(t, r);
    if (r < t)
      throw new RangeError("End date must be >= start date");
    return `${this.format(t)} – ${this.format(r)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(t, r) {
    if (typeof this.numberFormatter.formatRangeToParts == "function")
      return this.numberFormatter.formatRangeToParts(t, r);
    if (r < t)
      throw new RangeError("End date must be >= start date");
    let n = this.numberFormatter.formatToParts(t), a = this.numberFormatter.formatToParts(r);
    return [
      ...n.map((i) => ({
        ...i,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...a.map((i) => ({
        ...i,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.numberFormatter.resolvedOptions();
    return !lr && this.options.signDisplay != null && (t = {
      ...t,
      signDisplay: this.options.signDisplay
    }), !St && this.options.style === "unit" && (t = {
      ...t,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), t;
  }
  constructor(t, r = {}) {
    this.numberFormatter = Mo(t, r), this.options = r;
  }
}
function Mo(e, t = {}) {
  let { numberingSystem: r } = t;
  if (r && e.indexOf("-u-nu-") === -1 && (e = `${e}-u-nu-${r}`), t.style === "unit" && !St) {
    var n;
    let { unit: o, unitDisplay: u = "short" } = t;
    if (!o)
      throw new Error('unit option must be provided with style: "unit"');
    if (!(!((n = Cn[o]) === null || n === void 0) && n[u]))
      throw new Error(`Unsupported unit ${o} with unitDisplay = ${u}`);
    t = {
      ...t,
      style: "decimal"
    };
  }
  let a = e + (t ? Object.entries(t).sort((o, u) => o[0] < u[0] ? -1 : 1).join() : "");
  if (Zt.has(a))
    return Zt.get(a);
  let i = new Intl.NumberFormat(e, t);
  return Zt.set(a, i), i;
}
function Vo(e, t, r) {
  if (t === "auto")
    return e.format(r);
  if (t === "never")
    return e.format(Math.abs(r));
  {
    let n = !1;
    if (t === "always" ? n = r > 0 || Object.is(r, 0) : t === "exceptZero" && (Object.is(r, -0) || Object.is(r, 0) ? r = Math.abs(r) : n = r > 0), n) {
      let a = e.format(-r), i = e.format(r), o = a.replace(i, "").replace(/\u200e|\u061C/, "");
      return [
        ...o
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), a.replace(i, "!!!").replace(o, "+").replace("!!!", i);
    } else
      return e.format(r);
  }
}
const Oo = new RegExp("^.*\\(.*\\).*$"), Ao = [
  "latn",
  "arab",
  "hanidec"
];
class kn {
  /**
  * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
  */
  parse(t) {
    return Jt(this.locale, this.options, t).parse(t);
  }
  /**
  * Returns whether the given string could potentially be a valid number. This should be used to
  * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
  * of the minus/plus sign characters can be checked.
  */
  isValidPartialNumber(t, r, n) {
    return Jt(this.locale, this.options, t).isValidPartialNumber(t, r, n);
  }
  /**
  * Returns a numbering system for which the given string is valid in the current locale.
  * If no numbering system could be detected, the default numbering system for the current
  * locale is returned.
  */
  getNumberingSystem(t) {
    return Jt(this.locale, this.options, t).options.numberingSystem;
  }
  constructor(t, r = {}) {
    this.locale = t, this.options = r;
  }
}
const Hr = /* @__PURE__ */ new Map();
function Jt(e, t, r) {
  let n = qr(e, t);
  if (!e.includes("-nu-") && !n.isValidPartialNumber(r)) {
    for (let a of Ao)
      if (a !== n.options.numberingSystem) {
        let i = qr(e + (e.includes("-u-") ? "-nu-" : "-u-nu-") + a, t);
        if (i.isValidPartialNumber(r))
          return i;
      }
  }
  return n;
}
function qr(e, t) {
  let r = e + (t ? Object.entries(t).sort((a, i) => a[0] < i[0] ? -1 : 1).join() : ""), n = Hr.get(r);
  return n || (n = new Bo(e, t), Hr.set(r, n)), n;
}
class Bo {
  parse(t) {
    let r = this.sanitize(t);
    if (r = gt(r, this.symbols.group, "").replace(this.symbols.decimal, ".").replace(this.symbols.minusSign, "-").replace(this.symbols.numeral, this.symbols.index), this.options.style === "percent") {
      let a = r.indexOf("-");
      r = r.replace("-", "");
      let i = r.indexOf(".");
      i === -1 && (i = r.length), r = r.replace(".", ""), i - 2 === 0 ? r = `0.${r}` : i - 2 === -1 ? r = `0.0${r}` : i - 2 === -2 ? r = "0.00" : r = `${r.slice(0, i - 2)}.${r.slice(i - 2)}`, a > -1 && (r = `-${r}`);
    }
    let n = r ? +r : NaN;
    if (isNaN(n))
      return NaN;
    if (this.options.style === "percent") {
      let a = {
        ...this.options,
        style: "decimal",
        minimumFractionDigits: Math.min(this.options.minimumFractionDigits + 2, 20),
        maximumFractionDigits: Math.min(this.options.maximumFractionDigits + 2, 20)
      };
      return new kn(this.locale, a).parse(new Tt(this.locale, a).format(n));
    }
    return this.options.currencySign === "accounting" && Oo.test(t) && (n = -1 * n), n;
  }
  sanitize(t) {
    return t = t.replace(this.symbols.literals, ""), t = t.replace("-", this.symbols.minusSign), this.options.numberingSystem === "arab" && (t = t.replace(",", this.symbols.decimal), t = t.replace(String.fromCharCode(1548), this.symbols.decimal), t = gt(t, ".", this.symbols.group)), this.options.locale === "fr-FR" && (t = gt(t, ".", String.fromCharCode(8239))), t;
  }
  isValidPartialNumber(t, r = -1 / 0, n = 1 / 0) {
    return t = this.sanitize(t), t.startsWith(this.symbols.minusSign) && r < 0 ? t = t.slice(this.symbols.minusSign.length) : this.symbols.plusSign && t.startsWith(this.symbols.plusSign) && n > 0 && (t = t.slice(this.symbols.plusSign.length)), t.startsWith(this.symbols.group) || t.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0 ? !1 : (t = gt(t, this.symbols.group, "").replace(this.symbols.numeral, "").replace(this.symbols.decimal, ""), t.length === 0);
  }
  constructor(t, r = {}) {
    this.locale = t, this.formatter = new Intl.NumberFormat(t, r), this.options = this.formatter.resolvedOptions(), this.symbols = Ko(t, this.formatter, this.options, r);
    var n, a;
    this.options.style === "percent" && (((n = this.options.minimumFractionDigits) !== null && n !== void 0 ? n : 0) > 18 || ((a = this.options.maximumFractionDigits) !== null && a !== void 0 ? a : 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
  }
}
const Yr = /* @__PURE__ */ new Set([
  "decimal",
  "fraction",
  "integer",
  "minusSign",
  "plusSign",
  "group"
]), zo = [
  0,
  4,
  2,
  1,
  11,
  20,
  3,
  7,
  100,
  21,
  0.1,
  1.1
];
function Ko(e, t, r, n) {
  var a, i, o, u;
  let c = new Intl.NumberFormat(e, {
    ...r,
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 21
  }), f = c.formatToParts(-10000.111), v = c.formatToParts(10000.111), m = zo.map(($) => c.formatToParts($));
  var p;
  let y = (p = (a = f.find(($) => $.type === "minusSign")) === null || a === void 0 ? void 0 : a.value) !== null && p !== void 0 ? p : "-", C = (i = v.find(($) => $.type === "plusSign")) === null || i === void 0 ? void 0 : i.value;
  !C && ((n == null ? void 0 : n.signDisplay) === "exceptZero" || (n == null ? void 0 : n.signDisplay) === "always") && (C = "+");
  let k = (o = new Intl.NumberFormat(e, {
    ...r,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).formatToParts(1e-3).find(($) => $.type === "decimal")) === null || o === void 0 ? void 0 : o.value, D = (u = f.find(($) => $.type === "group")) === null || u === void 0 ? void 0 : u.value, P = f.filter(($) => !Yr.has($.type)).map(($) => Gr($.value)), T = m.flatMap(($) => $.filter((x) => !Yr.has(x.type)).map((x) => Gr(x.value))), h = [
    .../* @__PURE__ */ new Set([
      ...P,
      ...T
    ])
  ].sort(($, x) => x.length - $.length), w = h.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${h.join("|")}|[\\p{White_Space}]`, "gu"), M = [
    ...new Intl.NumberFormat(r.locale, {
      useGrouping: !1
    }).format(9876543210)
  ].reverse(), j = new Map(M.map(($, x) => [
    $,
    x
  ])), s = new RegExp(`[${M.join("")}]`, "g");
  return {
    minusSign: y,
    plusSign: C,
    decimal: k,
    group: D,
    literals: w,
    numeral: s,
    index: ($) => String(j.get($))
  };
}
function gt(e, t, r) {
  return e.replaceAll ? e.replaceAll(t, r) : e.split(t).join(r);
}
function Gr(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Uo(e) {
  let { minValue: t, maxValue: r, step: n, formatOptions: a, value: i, defaultValue: o, onChange: u, locale: c, isDisabled: f, isReadOnly: v } = e, [m, p] = br(i, isNaN(o) ? NaN : o, u), [y, C] = G(() => isNaN(m) ? "" : new Tt(c, a).format(m)), S = U(() => new kn(c, a), [
    c,
    a
  ]), k = U(() => S.getNumberingSystem(y), [
    S,
    y
  ]), D = U(() => new Tt(c, {
    ...a,
    numberingSystem: k
  }), [
    c,
    a,
    k
  ]), P = U(() => D.resolvedOptions(), [
    D
  ]), T = W((O) => isNaN(O) || O === null ? "" : D.format(O), [
    D
  ]), h = Tn({
    ...e,
    value: m
  }), w = isNaN(n) ? 1 : n;
  P.style === "percent" && isNaN(n) && (w = 0.01);
  let [M, j] = G(m), [s, L] = G(c), [$, x] = G(a);
  (!Object.is(m, M) || c !== s || a !== $) && (C(T(m)), j(m), L(c), x(a));
  let I = U(() => S.parse(y), [
    S,
    y
  ]), b = () => {
    if (!y.length) {
      p(NaN), C(i === void 0 ? "" : T(m));
      return;
    }
    if (isNaN(I)) {
      C(T(m));
      return;
    }
    let O;
    isNaN(n) ? O = ko(I, t, r) : O = Fe(I, t, r, n), O = S.parse(T(O)), p(O), C(T(i === void 0 ? O : m));
  }, _ = (O, pe) => {
    let ce = I;
    if (isNaN(ce)) {
      let ue = isNaN(pe) ? 0 : pe;
      return Fe(ue, t, r, w);
    } else {
      let ue = Fe(ce, t, r, w);
      return O === "+" && ue > ce || O === "-" && ue < ce ? ue : Fe(Xt(O, ce, w), t, r, w);
    }
  }, V = () => {
    let O = _("+", t);
    O === m && C(T(O)), p(O), h.commitValidation();
  }, Z = () => {
    let O = _("-", r);
    O === m && C(T(O)), p(O), h.commitValidation();
  }, oe = () => {
    r != null && (p(Fe(r, t, r, w)), h.commitValidation());
  }, te = () => {
    t != null && (p(t), h.commitValidation());
  }, ae = U(() => !f && !v && (isNaN(I) || isNaN(r) || Fe(I, t, r, w) > I || Xt("+", I, w) <= r), [
    f,
    v,
    t,
    r,
    w,
    I
  ]), fe = U(() => !f && !v && (isNaN(I) || isNaN(t) || Fe(I, t, r, w) < I || Xt("-", I, w) >= t), [
    f,
    v,
    t,
    r,
    w,
    I
  ]);
  return {
    ...h,
    validate: (O) => S.isValidPartialNumber(O, t, r),
    increment: V,
    incrementToMax: oe,
    decrement: Z,
    decrementToMin: te,
    canIncrement: ae,
    canDecrement: fe,
    minValue: t,
    maxValue: r,
    numberValue: I,
    setNumberValue: p,
    setInputValue: C,
    inputValue: y,
    commit: b
  };
}
function Xt(e, t, r) {
  let n = e === "+" ? t + r : t - r;
  if (t % 1 !== 0 || r % 1 !== 0) {
    const a = t.toString().split("."), i = r.toString().split("."), o = a[1] && a[1].length || 0, u = i[1] && i[1].length || 0, c = Math.pow(10, Math.max(o, u));
    t = Math.round(t * c), r = Math.round(r * c), n = e === "+" ? t + r : t - r, n /= c;
  }
  return n;
}
function Wo(e = {}) {
  let { isReadOnly: t } = e, [r, n] = br(e.isSelected, e.defaultSelected || !1, e.onChange);
  function a(o) {
    t || n(o);
  }
  function i() {
    t || n(!r);
  }
  return {
    isSelected: r,
    setSelected: a,
    toggle: i
  };
}
const Ct = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, Ln = /* @__PURE__ */ le.createContext(Ct), Ho = /* @__PURE__ */ le.createContext(!1);
let qo = !!(typeof window < "u" && window.document && window.document.createElement), Qt = /* @__PURE__ */ new WeakMap();
function Yo(e = !1) {
  let t = me(Ln), r = Y(null);
  if (r.current === null && !e) {
    var n, a;
    let i = (a = le.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || a === void 0 || (n = a.ReactCurrentOwner) === null || n === void 0 ? void 0 : n.current;
    if (i) {
      let o = Qt.get(i);
      o == null ? Qt.set(i, {
        id: t.current,
        state: i.memoizedState
      }) : i.memoizedState !== o.state && (t.current = o.id, Qt.delete(i));
    }
    r.current = ++t.current;
  }
  return r.current;
}
function Go(e) {
  let t = me(Ln);
  t === Ct && !qo && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let r = Yo(!!e), n = t === Ct && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${n}-${r}`;
}
function Zo(e) {
  let t = le.useId(), [r] = G(Dn()), n = r || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${Ct.prefix}`;
  return e || `${n}-${t}`;
}
const Jo = typeof le.useId == "function" ? Zo : Go;
function Xo() {
  return !1;
}
function Qo() {
  return !0;
}
function es(e) {
  return () => {
  };
}
function Dn() {
  return typeof le.useSyncExternalStore == "function" ? le.useSyncExternalStore(es, Xo, Qo) : me(Ho);
}
function Fn(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (r = Fn(e[t])) && (n && (n += " "), n += r);
    else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function ts() {
  for (var e, t, r = 0, n = ""; r < arguments.length; )
    (e = arguments[r++]) && (t = Fn(e)) && (n && (n += " "), n += t);
  return n;
}
const Re = typeof document < "u" ? le.useLayoutEffect : () => {
};
function Q(e) {
  const t = Y(null);
  return Re(() => {
    t.current = e;
  }, [
    e
  ]), W((...r) => {
    const n = t.current;
    return n(...r);
  }, []);
}
function rs(e) {
  let [t, r] = G(e), n = Y(null), a = Q(() => {
    let o = n.current.next();
    if (o.done) {
      n.current = null;
      return;
    }
    t === o.value ? a() : r(o.value);
  });
  Re(() => {
    n.current && a();
  });
  let i = Q((o) => {
    n.current = o(t), a();
  });
  return [
    t,
    i
  ];
}
let ns = !!(typeof window < "u" && window.document && window.document.createElement), kt = /* @__PURE__ */ new Map();
function Ie(e) {
  let [t, r] = G(e), n = Y(null), a = Jo(t), i = W((o) => {
    n.current = o;
  }, []);
  return ns && kt.set(a, i), Re(() => {
    let o = a;
    return () => {
      kt.delete(o);
    };
  }, [
    a
  ]), ee(() => {
    let o = n.current;
    o && (n.current = null, r(o));
  }), a;
}
function as(e, t) {
  if (e === t)
    return e;
  let r = kt.get(e);
  if (r)
    return r(t), t;
  let n = kt.get(t);
  return n ? (n(e), e) : t;
}
function Zr(e = []) {
  let t = Ie(), [r, n] = rs(t), a = W(() => {
    n(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    n
  ]);
  return Re(a, [
    t,
    a,
    ...e
  ]), r;
}
function jn(...e) {
  return (...t) => {
    for (let r of e)
      typeof r == "function" && r(...t);
  };
}
const Se = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, Lt = (e) => e && "window" in e && e.window === e ? e : Se(e).defaultView || window;
function ne(...e) {
  let t = {
    ...e[0]
  };
  for (let r = 1; r < e.length; r++) {
    let n = e[r];
    for (let a in n) {
      let i = t[a], o = n[a];
      typeof i == "function" && typeof o == "function" && // This is a lot faster than a regex.
      a[0] === "o" && a[1] === "n" && a.charCodeAt(2) >= /* 'A' */
      65 && a.charCodeAt(2) <= /* 'Z' */
      90 ? t[a] = jn(i, o) : (a === "className" || a === "UNSAFE_className") && typeof i == "string" && typeof o == "string" ? t[a] = ts(i, o) : a === "id" && i && o ? t.id = as(i, o) : t[a] = o !== void 0 ? o : i;
    }
  }
  return t;
}
const is = /* @__PURE__ */ new Set([
  "id"
]), ls = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), os = /* @__PURE__ */ new Set([
  "href",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), ss = /^(data-.*)$/;
function jt(e, t = {}) {
  let { labelable: r, isLink: n, propNames: a } = t, i = {};
  for (const o in e)
    Object.prototype.hasOwnProperty.call(e, o) && (is.has(o) || r && ls.has(o) || n && os.has(o) || a != null && a.has(o) || ss.test(o)) && (i[o] = e[o]);
  return i;
}
function je(e) {
  if (cs())
    e.focus({
      preventScroll: !0
    });
  else {
    let t = us(e);
    e.focus(), ds(t);
  }
}
let ht = null;
function cs() {
  if (ht == null) {
    ht = !1;
    try {
      var e = document.createElement("div");
      e.focus({
        get preventScroll() {
          return ht = !0, !0;
        }
      });
    } catch {
    }
  }
  return ht;
}
function us(e) {
  for (var t = e.parentNode, r = [], n = document.scrollingElement || document.documentElement; t instanceof HTMLElement && t !== n; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && r.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return n instanceof HTMLElement && r.push({
    element: n,
    scrollTop: n.scrollTop,
    scrollLeft: n.scrollLeft
  }), r;
}
function ds(e) {
  for (let { element: t, scrollTop: r, scrollLeft: n } of e)
    t.scrollTop = r, t.scrollLeft = n;
}
function It(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((r) => e.test(r.brand))) || e.test(window.navigator.userAgent);
}
function mr(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function ot() {
  return mr(/^Mac/i);
}
function In() {
  return mr(/^iPhone/i);
}
function Nn() {
  return mr(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  ot() && navigator.maxTouchPoints > 1;
}
function vr() {
  return In() || Nn();
}
function fs() {
  return It(/AppleWebKit/i) && !ps();
}
function ps() {
  return It(/Chrome/i);
}
function gr() {
  return It(/Android/i);
}
function bs() {
  return It(/Firefox/i);
}
function st(e, t, r = !0) {
  var n, a;
  let { metaKey: i, ctrlKey: o, altKey: u, shiftKey: c } = t;
  bs() && (!((a = window.event) === null || a === void 0 || (n = a.type) === null || n === void 0) && n.startsWith("key")) && e.target === "_blank" && (ot() ? i = !0 : o = !0);
  let f = fs() && ot() && !Nn() ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: i,
    ctrlKey: o,
    altKey: u,
    shiftKey: c
  }) : new MouseEvent("click", {
    metaKey: i,
    ctrlKey: o,
    altKey: u,
    shiftKey: c,
    bubbles: !0,
    cancelable: !0
  });
  st.isOpening = r, je(e), e.dispatchEvent(f), st.isOpening = !1;
}
st.isOpening = !1;
let Ye = /* @__PURE__ */ new Map(), or = /* @__PURE__ */ new Set();
function Jr() {
  if (typeof window > "u")
    return;
  let e = (r) => {
    let n = Ye.get(r.target);
    n || (n = /* @__PURE__ */ new Set(), Ye.set(r.target, n), r.target.addEventListener("transitioncancel", t)), n.add(r.propertyName);
  }, t = (r) => {
    let n = Ye.get(r.target);
    if (n && (n.delete(r.propertyName), n.size === 0 && (r.target.removeEventListener("transitioncancel", t), Ye.delete(r.target)), Ye.size === 0)) {
      for (let a of or)
        a();
      or.clear();
    }
  };
  document.body.addEventListener("transitionrun", e), document.body.addEventListener("transitionend", t);
}
typeof document < "u" && (document.readyState !== "loading" ? Jr() : document.addEventListener("DOMContentLoaded", Jr));
function Rn(e) {
  requestAnimationFrame(() => {
    Ye.size === 0 ? e() : or.add(e);
  });
}
function Mn() {
  let e = Y(/* @__PURE__ */ new Map()), t = W((a, i, o, u) => {
    let c = u != null && u.once ? (...f) => {
      e.current.delete(o), o(...f);
    } : o;
    e.current.set(o, {
      type: i,
      eventTarget: a,
      fn: c,
      options: u
    }), a.addEventListener(i, o, u);
  }, []), r = W((a, i, o, u) => {
    var c;
    let f = ((c = e.current.get(o)) === null || c === void 0 ? void 0 : c.fn) || o;
    a.removeEventListener(i, f, u), e.current.delete(o);
  }, []), n = W(() => {
    e.current.forEach((a, i) => {
      r(a.eventTarget, a.type, i, a.options);
    });
  }, [
    r
  ]);
  return ee(() => n, [
    n
  ]), {
    addGlobalListener: t,
    removeGlobalListener: r,
    removeAllGlobalListeners: n
  };
}
function ms(e, t) {
  let { id: r, "aria-label": n, "aria-labelledby": a } = e;
  return r = Ie(r), a && n ? a = [
    .../* @__PURE__ */ new Set([
      r,
      ...a.trim().split(/\s+/)
    ])
  ].join(" ") : a && (a = a.trim().split(/\s+/).join(" ")), !n && !a && t && (n = t), {
    id: r,
    "aria-label": n,
    "aria-labelledby": a
  };
}
function Vn(e, t) {
  Re(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref.current = null;
      };
  });
}
function vs(e, t, r, n) {
  let a = Q(r), i = r == null;
  ee(() => {
    if (i)
      return;
    let o = e.current;
    return o.addEventListener(t, a, n), () => {
      o.removeEventListener(t, a, n);
    };
  }, [
    e,
    t,
    n,
    i,
    a
  ]);
}
function sr(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : gr() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function gs(e) {
  return !gr() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function hr(e, t, r) {
  let n = Y(t), a = Q(() => {
    r && r(n.current);
  });
  ee(() => {
    var i;
    let o = e == null || (i = e.current) === null || i === void 0 ? void 0 : i.form;
    return o == null || o.addEventListener("reset", a), () => {
      o == null || o.removeEventListener("reset", a);
    };
  }, [
    e,
    a
  ]);
}
function hs(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function On(e, t, r) {
  if (!t.has(e))
    throw new TypeError("attempted to " + r + " private field on non-instance");
  return t.get(e);
}
function _s(e, t) {
  var r = On(e, t, "get");
  return hs(e, r);
}
function $s(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function ys(e, t, r) {
  $s(e, t), t.set(e, r);
}
function xs(e, t, r) {
  if (t.set)
    t.set.call(e, r);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = r;
  }
}
function Xr(e, t, r) {
  var n = On(e, t, "set");
  return xs(e, n, r), r;
}
let Ge = "default", cr = "", Pt = /* @__PURE__ */ new WeakMap();
function Qr(e) {
  if (vr()) {
    if (Ge === "default") {
      const t = Se(e);
      cr = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    Ge = "disabled";
  } else
    (e instanceof HTMLElement || e instanceof SVGElement) && (Pt.set(e, e.style.userSelect), e.style.userSelect = "none");
}
function _t(e) {
  if (vr()) {
    if (Ge !== "disabled")
      return;
    Ge = "restoring", setTimeout(() => {
      Rn(() => {
        if (Ge === "restoring") {
          const t = Se(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = cr || ""), cr = "", Ge = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && Pt.has(e)) {
    let t = Pt.get(e);
    e.style.userSelect === "none" && t && (e.style.userSelect = t), e.getAttribute("style") === "" && e.removeAttribute("style"), Pt.delete(e);
  }
}
const An = le.createContext({
  register: () => {
  }
});
An.displayName = "PressResponderContext";
function Ps(e) {
  let t = me(An);
  if (t) {
    let { register: r, ...n } = t;
    e = ne(n, e), r();
  }
  return Vn(t, e.ref), e;
}
var $t = /* @__PURE__ */ new WeakMap();
class yt {
  continuePropagation() {
    Xr(this, $t, !1);
  }
  get shouldStopPropagation() {
    return _s(this, $t);
  }
  constructor(t, r, n) {
    ys(this, $t, {
      writable: !0,
      value: void 0
    }), Xr(this, $t, !0), this.type = t, this.pointerType = r, this.target = n.currentTarget, this.shiftKey = n.shiftKey, this.metaKey = n.metaKey, this.ctrlKey = n.ctrlKey, this.altKey = n.altKey;
  }
}
const en = Symbol("linkClicked");
function _r(e) {
  let {
    onPress: t,
    onPressChange: r,
    onPressStart: n,
    onPressEnd: a,
    onPressUp: i,
    isDisabled: o,
    isPressed: u,
    preventFocusOnPress: c,
    shouldCancelOnPointerExit: f,
    allowTextSelectionOnPress: v,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: m,
    ...p
  } = Ps(e), [y, C] = G(!1), S = Y({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    ignoreClickAfterPress: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null
  }), { addGlobalListener: k, removeAllGlobalListeners: D } = Mn(), P = Q((s, L) => {
    let $ = S.current;
    if (o || $.didFirePressStart)
      return !1;
    let x = !0;
    if ($.isTriggeringEvent = !0, n) {
      let I = new yt("pressstart", L, s);
      n(I), x = I.shouldStopPropagation;
    }
    return r && r(!0), $.isTriggeringEvent = !1, $.didFirePressStart = !0, C(!0), x;
  }), T = Q((s, L, $ = !0) => {
    let x = S.current;
    if (!x.didFirePressStart)
      return !1;
    x.ignoreClickAfterPress = !0, x.didFirePressStart = !1, x.isTriggeringEvent = !0;
    let I = !0;
    if (a) {
      let b = new yt("pressend", L, s);
      a(b), I = b.shouldStopPropagation;
    }
    if (r && r(!1), C(!1), t && $ && !o) {
      let b = new yt("press", L, s);
      t(b), I && (I = b.shouldStopPropagation);
    }
    return x.isTriggeringEvent = !1, I;
  }), h = Q((s, L) => {
    let $ = S.current;
    if (o)
      return !1;
    if (i) {
      $.isTriggeringEvent = !0;
      let x = new yt("pressup", L, s);
      return i(x), $.isTriggeringEvent = !1, x.shouldStopPropagation;
    }
    return !0;
  }), w = Q((s) => {
    let L = S.current;
    L.isPressed && L.target && (L.isOverTarget && L.pointerType != null && T(_e(L.target, s), L.pointerType, !1), L.isPressed = !1, L.isOverTarget = !1, L.activePointerId = null, L.pointerType = null, D(), v || _t(L.target));
  }), M = Q((s) => {
    f && w(s);
  }), j = U(() => {
    let s = S.current, L = {
      onKeyDown(x) {
        if (er(x.nativeEvent, x.currentTarget) && x.currentTarget.contains(x.target)) {
          var I;
          rn(x.target, x.key) && x.preventDefault();
          let b = !0;
          !s.isPressed && !x.repeat && (s.target = x.currentTarget, s.isPressed = !0, b = P(x, "keyboard"), k(Se(x.currentTarget), "keyup", $, !1)), b && x.stopPropagation(), x.metaKey && ot() && ((I = s.metaKeyEvents) === null || I === void 0 || I.set(x.key, x.nativeEvent));
        } else
          x.key === "Meta" && (s.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onKeyUp(x) {
        er(x.nativeEvent, x.currentTarget) && !x.repeat && x.currentTarget.contains(x.target) && s.target && h(_e(s.target, x), "keyboard");
      },
      onClick(x) {
        if (!(x && !x.currentTarget.contains(x.target)) && x && x.button === 0 && !s.isTriggeringEvent && !st.isOpening) {
          let I = !0;
          if (o && x.preventDefault(), !s.ignoreClickAfterPress && !s.ignoreEmulatedMouseEvents && !s.isPressed && (s.pointerType === "virtual" || sr(x.nativeEvent))) {
            !o && !c && je(x.currentTarget);
            let b = P(x, "virtual"), _ = h(x, "virtual"), V = T(x, "virtual");
            I = b && _ && V;
          }
          s.ignoreEmulatedMouseEvents = !1, s.ignoreClickAfterPress = !1, I && x.stopPropagation();
        }
      }
    }, $ = (x) => {
      var I;
      if (s.isPressed && s.target && er(x, s.target)) {
        var b;
        rn(x.target, x.key) && x.preventDefault();
        let V = x.target, Z = T(_e(s.target, x), "keyboard", s.target.contains(V));
        D(), Z && x.stopPropagation(), x.key !== "Enter" && $r(s.target) && s.target.contains(V) && !x[en] && (x[en] = !0, st(s.target, x, !1)), s.isPressed = !1, (b = s.metaKeyEvents) === null || b === void 0 || b.delete(x.key);
      } else if (x.key === "Meta" && (!((I = s.metaKeyEvents) === null || I === void 0) && I.size)) {
        var _;
        let V = s.metaKeyEvents;
        s.metaKeyEvents = void 0;
        for (let Z of V.values())
          (_ = s.target) === null || _ === void 0 || _.dispatchEvent(new KeyboardEvent("keyup", Z));
      }
    };
    if (typeof PointerEvent < "u") {
      L.onPointerDown = (_) => {
        if (_.button !== 0 || !_.currentTarget.contains(_.target))
          return;
        if (gs(_.nativeEvent)) {
          s.pointerType = "virtual";
          return;
        }
        tr(_.currentTarget) && _.preventDefault(), s.pointerType = _.pointerType;
        let V = !0;
        s.isPressed || (s.isPressed = !0, s.isOverTarget = !0, s.activePointerId = _.pointerId, s.target = _.currentTarget, !o && !c && je(_.currentTarget), v || Qr(s.target), V = P(_, s.pointerType), k(Se(_.currentTarget), "pointermove", x, !1), k(Se(_.currentTarget), "pointerup", I, !1), k(Se(_.currentTarget), "pointercancel", b, !1)), V && _.stopPropagation();
      }, L.onMouseDown = (_) => {
        _.currentTarget.contains(_.target) && _.button === 0 && (tr(_.currentTarget) && _.preventDefault(), _.stopPropagation());
      }, L.onPointerUp = (_) => {
        !_.currentTarget.contains(_.target) || s.pointerType === "virtual" || _.button === 0 && We(_, _.currentTarget) && h(_, s.pointerType || _.pointerType);
      };
      let x = (_) => {
        _.pointerId === s.activePointerId && (s.target && We(_, s.target) ? !s.isOverTarget && s.pointerType != null && (s.isOverTarget = !0, P(_e(s.target, _), s.pointerType)) : s.target && s.isOverTarget && s.pointerType != null && (s.isOverTarget = !1, T(_e(s.target, _), s.pointerType, !1), M(_)));
      }, I = (_) => {
        _.pointerId === s.activePointerId && s.isPressed && _.button === 0 && s.target && (We(_, s.target) && s.pointerType != null ? T(_e(s.target, _), s.pointerType) : s.isOverTarget && s.pointerType != null && T(_e(s.target, _), s.pointerType, !1), s.isPressed = !1, s.isOverTarget = !1, s.activePointerId = null, s.pointerType = null, D(), v || _t(s.target));
      }, b = (_) => {
        w(_);
      };
      L.onDragStart = (_) => {
        _.currentTarget.contains(_.target) && w(_);
      };
    } else {
      L.onMouseDown = (b) => {
        if (b.button !== 0 || !b.currentTarget.contains(b.target))
          return;
        if (tr(b.currentTarget) && b.preventDefault(), s.ignoreEmulatedMouseEvents) {
          b.stopPropagation();
          return;
        }
        s.isPressed = !0, s.isOverTarget = !0, s.target = b.currentTarget, s.pointerType = sr(b.nativeEvent) ? "virtual" : "mouse", !o && !c && je(b.currentTarget), P(b, s.pointerType) && b.stopPropagation(), k(Se(b.currentTarget), "mouseup", x, !1);
      }, L.onMouseEnter = (b) => {
        if (!b.currentTarget.contains(b.target))
          return;
        let _ = !0;
        s.isPressed && !s.ignoreEmulatedMouseEvents && s.pointerType != null && (s.isOverTarget = !0, _ = P(b, s.pointerType)), _ && b.stopPropagation();
      }, L.onMouseLeave = (b) => {
        if (!b.currentTarget.contains(b.target))
          return;
        let _ = !0;
        s.isPressed && !s.ignoreEmulatedMouseEvents && s.pointerType != null && (s.isOverTarget = !1, _ = T(b, s.pointerType, !1), M(b)), _ && b.stopPropagation();
      }, L.onMouseUp = (b) => {
        b.currentTarget.contains(b.target) && !s.ignoreEmulatedMouseEvents && b.button === 0 && h(b, s.pointerType || "mouse");
      };
      let x = (b) => {
        if (b.button === 0) {
          if (s.isPressed = !1, D(), s.ignoreEmulatedMouseEvents) {
            s.ignoreEmulatedMouseEvents = !1;
            return;
          }
          s.target && We(b, s.target) && s.pointerType != null ? T(_e(s.target, b), s.pointerType) : s.target && s.isOverTarget && s.pointerType != null && T(_e(s.target, b), s.pointerType, !1), s.isOverTarget = !1;
        }
      };
      L.onTouchStart = (b) => {
        if (!b.currentTarget.contains(b.target))
          return;
        let _ = ws(b.nativeEvent);
        if (!_)
          return;
        s.activePointerId = _.identifier, s.ignoreEmulatedMouseEvents = !0, s.isOverTarget = !0, s.isPressed = !0, s.target = b.currentTarget, s.pointerType = "touch", !o && !c && je(b.currentTarget), v || Qr(s.target), P(b, s.pointerType) && b.stopPropagation(), k(Lt(b.currentTarget), "scroll", I, !0);
      }, L.onTouchMove = (b) => {
        if (!b.currentTarget.contains(b.target))
          return;
        if (!s.isPressed) {
          b.stopPropagation();
          return;
        }
        let _ = tn(b.nativeEvent, s.activePointerId), V = !0;
        _ && We(_, b.currentTarget) ? !s.isOverTarget && s.pointerType != null && (s.isOverTarget = !0, V = P(b, s.pointerType)) : s.isOverTarget && s.pointerType != null && (s.isOverTarget = !1, V = T(b, s.pointerType, !1), M(b)), V && b.stopPropagation();
      }, L.onTouchEnd = (b) => {
        if (!b.currentTarget.contains(b.target))
          return;
        if (!s.isPressed) {
          b.stopPropagation();
          return;
        }
        let _ = tn(b.nativeEvent, s.activePointerId), V = !0;
        _ && We(_, b.currentTarget) && s.pointerType != null ? (h(b, s.pointerType), V = T(b, s.pointerType)) : s.isOverTarget && s.pointerType != null && (V = T(b, s.pointerType, !1)), V && b.stopPropagation(), s.isPressed = !1, s.activePointerId = null, s.isOverTarget = !1, s.ignoreEmulatedMouseEvents = !0, s.target && !v && _t(s.target), D();
      }, L.onTouchCancel = (b) => {
        b.currentTarget.contains(b.target) && (b.stopPropagation(), s.isPressed && w(b));
      };
      let I = (b) => {
        s.isPressed && b.target.contains(s.target) && w({
          currentTarget: s.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      L.onDragStart = (b) => {
        b.currentTarget.contains(b.target) && w(b);
      };
    }
    return L;
  }, [
    k,
    o,
    c,
    D,
    v,
    w,
    M,
    T,
    P,
    h
  ]);
  return ee(() => () => {
    var s;
    v || _t((s = S.current.target) !== null && s !== void 0 ? s : void 0);
  }, [
    v
  ]), {
    isPressed: u || y,
    pressProps: ne(p, j)
  };
}
function $r(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function er(e, t) {
  const { key: r, code: n } = e, a = t, i = a.getAttribute("role");
  return (r === "Enter" || r === " " || r === "Spacebar" || n === "Space") && !(a instanceof Lt(a).HTMLInputElement && !Bn(a, r) || a instanceof Lt(a).HTMLTextAreaElement || a.isContentEditable) && // Links should only trigger with Enter key
  !((i === "link" || !i && $r(a)) && r !== "Enter");
}
function ws(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function tn(e, t) {
  const r = e.changedTouches;
  for (let n = 0; n < r.length; n++) {
    const a = r[n];
    if (a.identifier === t)
      return a;
  }
  return null;
}
function _e(e, t) {
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey
  };
}
function Es(e) {
  let t = 0, r = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? r = e.height / 2 : e.radiusY !== void 0 && (r = e.radiusY), {
    top: e.clientY - r,
    right: e.clientX + t,
    bottom: e.clientY + r,
    left: e.clientX - t
  };
}
function Ss(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function We(e, t) {
  let r = t.getBoundingClientRect(), n = Es(e);
  return Ss(r, n);
}
function tr(e) {
  return !(e instanceof HTMLElement) || !e.hasAttribute("draggable");
}
function rn(e, t) {
  return e instanceof HTMLInputElement ? !Bn(e, t) : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !$r(e);
}
const Ts = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Bn(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : Ts.has(e.type);
}
class Cs {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, r) {
    this.nativeEvent = r, this.target = r.target, this.currentTarget = r.currentTarget, this.relatedTarget = r.relatedTarget, this.bubbles = r.bubbles, this.cancelable = r.cancelable, this.defaultPrevented = r.defaultPrevented, this.eventPhase = r.eventPhase, this.isTrusted = r.isTrusted, this.timeStamp = r.timeStamp, this.type = t;
  }
}
function zn(e) {
  let t = Y({
    isFocused: !1,
    observer: null
  });
  Re(() => {
    const n = t.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []);
  let r = Q((n) => {
    e == null || e(n);
  });
  return W((n) => {
    if (n.target instanceof HTMLButtonElement || n.target instanceof HTMLInputElement || n.target instanceof HTMLTextAreaElement || n.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let a = n.target, i = (o) => {
        t.current.isFocused = !1, a.disabled && r(new Cs("blur", o)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      a.addEventListener("focusout", i, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && a.disabled) {
          var o;
          (o = t.current.observer) === null || o === void 0 || o.disconnect();
          let u = a === document.activeElement ? null : document.activeElement;
          a.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: u
          })), a.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: u
          }));
        }
      }), t.current.observer.observe(a, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    r
  ]);
}
function yr(e) {
  let { isDisabled: t, onFocus: r, onBlur: n, onFocusChange: a } = e;
  const i = W((c) => {
    if (c.target === c.currentTarget)
      return n && n(c), a && a(!1), !0;
  }, [
    n,
    a
  ]), o = zn(i), u = W((c) => {
    c.target === c.currentTarget && document.activeElement === c.target && (r && r(c), a && a(!0), o(c));
  }, [
    a,
    r,
    o
  ]);
  return {
    focusProps: {
      onFocus: !t && (r || a || n) ? u : void 0,
      onBlur: !t && (n || a) ? i : void 0
    }
  };
}
let Me = null, ur = /* @__PURE__ */ new Set(), nn = !1, Ne = !1, dr = !1;
const ks = {
  Tab: !0,
  Escape: !0
};
function Nt(e, t) {
  for (let r of ur)
    r(e, t);
}
function Ls(e) {
  return !(e.metaKey || !ot() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function an(e) {
  Ne = !0, Ls(e) && (Me = "keyboard", Nt("keyboard", e));
}
function He(e) {
  Me = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (Ne = !0, Nt("pointer", e));
}
function Ds(e) {
  sr(e) && (Ne = !0, Me = "virtual");
}
function Fs(e) {
  e.target === window || e.target === document || (!Ne && !dr && (Me = "virtual", Nt("virtual", e)), Ne = !1, dr = !1);
}
function js() {
  Ne = !1, dr = !0;
}
function fr() {
  if (typeof window > "u" || nn)
    return;
  let e = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function() {
    Ne = !0, e.apply(this, arguments);
  }, document.addEventListener("keydown", an, !0), document.addEventListener("keyup", an, !0), document.addEventListener("click", Ds, !0), window.addEventListener("focus", Fs, !0), window.addEventListener("blur", js, !1), typeof PointerEvent < "u" ? (document.addEventListener("pointerdown", He, !0), document.addEventListener("pointermove", He, !0), document.addEventListener("pointerup", He, !0)) : (document.addEventListener("mousedown", He, !0), document.addEventListener("mousemove", He, !0), document.addEventListener("mouseup", He, !0)), nn = !0;
}
typeof document < "u" && (document.readyState !== "loading" ? fr() : document.addEventListener("DOMContentLoaded", fr));
function Kn() {
  return Me !== "pointer";
}
function Is() {
  return Me;
}
function Ns(e) {
  Me = e, Nt(e, null);
}
const Rs = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Ms(e, t, r) {
  var n;
  return e = e || (r == null ? void 0 : r.target) instanceof HTMLInputElement && !Rs.has(r == null || (n = r.target) === null || n === void 0 ? void 0 : n.type) || (r == null ? void 0 : r.target) instanceof HTMLTextAreaElement || (r == null ? void 0 : r.target) instanceof HTMLElement && (r == null ? void 0 : r.target.isContentEditable), !(e && t === "keyboard" && r instanceof KeyboardEvent && !ks[r.key]);
}
function Vs(e, t, r) {
  fr(), ee(() => {
    let n = (a, i) => {
      Ms(!!(r != null && r.isTextInput), a, i) && e(Kn());
    };
    return ur.add(n), () => {
      ur.delete(n);
    };
  }, t);
}
function Un(e) {
  let { isDisabled: t, onBlurWithin: r, onFocusWithin: n, onFocusWithinChange: a } = e, i = Y({
    isFocusWithin: !1
  }), o = W((f) => {
    i.current.isFocusWithin && !f.currentTarget.contains(f.relatedTarget) && (i.current.isFocusWithin = !1, r && r(f), a && a(!1));
  }, [
    r,
    a,
    i
  ]), u = zn(o), c = W((f) => {
    !i.current.isFocusWithin && document.activeElement === f.target && (n && n(f), a && a(!0), i.current.isFocusWithin = !0, u(f));
  }, [
    n,
    a,
    u
  ]);
  return t ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: c,
      onBlur: o
    }
  };
}
function ln(e) {
  if (!e)
    return;
  let t = !0;
  return (r) => {
    let n = {
      ...r,
      preventDefault() {
        r.preventDefault();
      },
      isDefaultPrevented() {
        return r.isDefaultPrevented();
      },
      stopPropagation() {
        console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
      },
      continuePropagation() {
        t = !1;
      }
    };
    e(n), t && r.stopPropagation();
  };
}
function Wn(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: ln(e.onKeyDown),
      onKeyUp: ln(e.onKeyUp)
    }
  };
}
function Os(e, t) {
  let { onScroll: r, isDisabled: n } = e, a = W((i) => {
    i.ctrlKey || (i.preventDefault(), i.stopPropagation(), r && r({
      deltaX: i.deltaX,
      deltaY: i.deltaY
    }));
  }, [
    r
  ]);
  vs(t, "wheel", n ? void 0 : a);
}
function As(e) {
  if (Is() === "virtual") {
    let t = document.activeElement;
    Rn(() => {
      document.activeElement === t && document.contains(e) && je(e);
    });
  } else
    je(e);
}
function Bs(e, t) {
  return !e || !t ? !1 : t.some((r) => r.contains(e));
}
class xr {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(t) {
    return this.fastMap.get(t);
  }
  addTreeNode(t, r, n) {
    let a = this.fastMap.get(r ?? null);
    if (!a)
      return;
    let i = new on({
      scopeRef: t
    });
    a.addChild(i), i.parent = a, this.fastMap.set(t, i), n && (i.nodeToRestore = n);
  }
  addNode(t) {
    this.fastMap.set(t.scopeRef, t);
  }
  removeTreeNode(t) {
    if (t === null)
      return;
    let r = this.fastMap.get(t);
    if (!r)
      return;
    let n = r.parent;
    for (let i of this.traverse())
      i !== r && r.nodeToRestore && i.nodeToRestore && r.scopeRef && r.scopeRef.current && Bs(i.nodeToRestore, r.scopeRef.current) && (i.nodeToRestore = r.nodeToRestore);
    let a = r.children;
    n && (n.removeChild(r), a.size > 0 && a.forEach((i) => n && n.addChild(i))), this.fastMap.delete(r.scopeRef);
  }
  // Pre Order Depth First
  *traverse(t = this.root) {
    if (t.scopeRef != null && (yield t), t.children.size > 0)
      for (let r of t.children)
        yield* this.traverse(r);
  }
  clone() {
    var t;
    let r = new xr();
    var n;
    for (let a of this.traverse())
      r.addTreeNode(a.scopeRef, (n = (t = a.parent) === null || t === void 0 ? void 0 : t.scopeRef) !== null && n !== void 0 ? n : null, a.nodeToRestore);
    return r;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new on({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class on {
  addChild(t) {
    this.children.add(t), t.parent = this;
  }
  removeChild(t) {
    this.children.delete(t), t.parent = void 0;
  }
  constructor(t) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = t.scopeRef;
  }
}
new xr();
function zs(e = {}) {
  let { autoFocus: t = !1, isTextInput: r, within: n } = e, a = Y({
    isFocused: !1,
    isFocusVisible: t || Kn()
  }), [i, o] = G(!1), [u, c] = G(() => a.current.isFocused && a.current.isFocusVisible), f = W(() => c(a.current.isFocused && a.current.isFocusVisible), []), v = W((y) => {
    a.current.isFocused = y, o(y), f();
  }, [
    f
  ]);
  Vs((y) => {
    a.current.isFocusVisible = y, f();
  }, [], {
    isTextInput: r
  });
  let { focusProps: m } = yr({
    isDisabled: n,
    onFocusChange: v
  }), { focusWithinProps: p } = Un({
    isDisabled: !n,
    onFocusWithinChange: v
  });
  return {
    isFocused: i,
    isFocusVisible: u,
    focusProps: n ? p : m
  };
}
let Ks = /* @__PURE__ */ le.createContext(null);
function Us(e) {
  let t = me(Ks) || {};
  Vn(t, e);
  let { ref: r, ...n } = t;
  return n;
}
function Pr(e, t) {
  let { focusProps: r } = yr(e), { keyboardProps: n } = Wn(e), a = ne(r, n), i = Us(t), o = e.isDisabled ? {} : i, u = Y(e.autoFocus);
  return ee(() => {
    u.current && t.current && As(t.current), u.current = !1;
  }, [
    t
  ]), {
    focusableProps: ne({
      ...a,
      tabIndex: e.excludeFromTabOrder && !e.isDisabled ? -1 : void 0
    }, o)
  };
}
const Ws = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), Hs = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function qs(e) {
  if (Intl.Locale) {
    let r = new Intl.Locale(e).maximize().script;
    return r ? Ws.has(r) : !1;
  }
  let t = e.split("-")[0];
  return Hs.has(t);
}
function Hn() {
  let e = typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: qs(e) ? "rtl" : "ltr"
  };
}
let pr = Hn(), it = /* @__PURE__ */ new Set();
function sn() {
  pr = Hn();
  for (let e of it)
    e(pr);
}
function Ys() {
  let e = Dn(), [t, r] = G(pr);
  return ee(() => (it.size === 0 && window.addEventListener("languagechange", sn), it.add(r), () => {
    it.delete(r), it.size === 0 && window.removeEventListener("languagechange", sn);
  }), []), e ? {
    locale: "en-US",
    direction: "ltr"
  } : t;
}
const Gs = /* @__PURE__ */ le.createContext(null);
function wr() {
  let e = Ys();
  return me(Gs) || e;
}
const cn = /* @__PURE__ */ new WeakMap();
function Zs(e) {
  let t = cn.get(e);
  return t || (t = new jo(e), cn.set(e, t)), t;
}
function qn(e) {
  let { locale: t } = wr(), r = U(() => Zs(e), [
    e
  ]);
  return U(() => new Ro(t, r), [
    t,
    r
  ]);
}
function un(e = {}) {
  let { locale: t } = wr();
  return U(() => new Tt(t, e), [
    t,
    e
  ]);
}
function Js(e, t) {
  let {
    elementType: r = "button",
    isDisabled: n,
    onPress: a,
    onPressStart: i,
    onPressEnd: o,
    onPressUp: u,
    onPressChange: c,
    preventFocusOnPress: f,
    allowFocusWhenDisabled: v,
    // @ts-ignore
    onClick: m,
    href: p,
    target: y,
    rel: C,
    type: S = "button"
  } = e, k;
  r === "button" ? k = {
    type: S,
    disabled: n
  } : k = {
    role: "button",
    tabIndex: n ? void 0 : 0,
    href: r === "a" && n ? void 0 : p,
    target: r === "a" ? y : void 0,
    type: r === "input" ? S : void 0,
    disabled: r === "input" ? n : void 0,
    "aria-disabled": !n || r === "input" ? void 0 : n,
    rel: r === "a" ? C : void 0
  };
  let { pressProps: D, isPressed: P } = _r({
    onPressStart: i,
    onPressEnd: o,
    onPressChange: c,
    onPress: a,
    onPressUp: u,
    isDisabled: n,
    preventFocusOnPress: f,
    ref: t
  }), { focusableProps: T } = Pr(e, t);
  v && (T.tabIndex = n ? -1 : T.tabIndex);
  let h = ne(T, D, jt(e, {
    labelable: !0
  }));
  return {
    isPressed: P,
    buttonProps: ne(k, h, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      onClick: (w) => {
        m && (m(w), console.warn("onClick is deprecated, please use onPress"));
      }
    })
  };
}
const Yn = 7e3;
let lt = null;
function Xs(e, t = "assertive", r = Yn) {
  lt || (lt = new ec()), lt.announce(e, t, r);
}
function Qs(e) {
  lt && lt.clear(e);
}
class ec {
  createLog(t) {
    let r = document.createElement("div");
    return r.setAttribute("role", "log"), r.setAttribute("aria-live", t), r.setAttribute("aria-relevant", "additions"), r;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, r = "assertive", n = Yn) {
    if (!this.node)
      return;
    let a = document.createElement("div");
    a.textContent = t, r === "assertive" ? this.assertiveLog.appendChild(a) : this.politeLog.appendChild(a), t !== "" && setTimeout(() => {
      a.remove();
    }, n);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node);
  }
}
function tc(e, t, r) {
  let { validationBehavior: n, focus: a } = e;
  Re(() => {
    if (n === "native" && (r != null && r.current)) {
      let c = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      r.current.setCustomValidity(c), r.current.hasAttribute("title") || (r.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(nc(r.current));
    }
  });
  let i = Q(() => {
    t.resetValidation();
  }), o = Q((c) => {
    var f;
    t.displayValidation.isInvalid || t.commitValidation();
    let v = r == null || (f = r.current) === null || f === void 0 ? void 0 : f.form;
    if (!c.defaultPrevented && r && v && ac(v) === r.current) {
      var m;
      a ? a() : (m = r.current) === null || m === void 0 || m.focus(), Ns("keyboard");
    }
    c.preventDefault();
  }), u = Q(() => {
    t.commitValidation();
  });
  ee(() => {
    let c = r == null ? void 0 : r.current;
    if (!c)
      return;
    let f = c.form;
    return c.addEventListener("invalid", o), c.addEventListener("change", u), f == null || f.addEventListener("reset", i), () => {
      c.removeEventListener("invalid", o), c.removeEventListener("change", u), f == null || f.removeEventListener("reset", i);
    };
  }, [
    r,
    o,
    u,
    i,
    n
  ]);
}
function rc(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function nc(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: rc(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function ac(e) {
  for (let t = 0; t < e.elements.length; t++) {
    let r = e.elements[t];
    if (!r.validity.valid)
      return r;
  }
  return null;
}
function ic(e, t, r) {
  let { isDisabled: n = !1, isReadOnly: a = !1, value: i, name: o, children: u, "aria-label": c, "aria-labelledby": f, validationState: v = "valid", isInvalid: m } = e, p = (h) => {
    h.stopPropagation(), t.setSelected(h.target.checked);
  }, y = u != null, C = c != null || f != null;
  !y && !C && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let { pressProps: S, isPressed: k } = _r({
    isDisabled: n
  }), { focusableProps: D } = Pr(e, r), P = ne(S, D), T = jt(e, {
    labelable: !0
  });
  return hr(r, t.isSelected, t.setSelected), {
    inputProps: ne(T, {
      "aria-invalid": m || v === "invalid" || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-controls": e["aria-controls"],
      "aria-readonly": a || void 0,
      onChange: p,
      disabled: n,
      ...i == null ? {} : {
        value: i
      },
      name: o,
      type: "checkbox",
      ...P
    }),
    isSelected: t.isSelected,
    isPressed: k,
    isDisabled: n,
    isReadOnly: a,
    isInvalid: m || v === "invalid"
  };
}
function lc(e) {
  let { id: t, label: r, "aria-labelledby": n, "aria-label": a, labelElementType: i = "label" } = e;
  t = Ie(t);
  let o = Ie(), u = {};
  r ? (n = n ? `${o} ${n}` : o, u = {
    id: o,
    htmlFor: i === "label" ? t : void 0
  }) : !n && !a && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let c = ms({
    id: t,
    "aria-label": a,
    "aria-labelledby": n
  });
  return {
    labelProps: u,
    fieldProps: c
  };
}
function oc(e) {
  let { description: t, errorMessage: r, isInvalid: n, validationState: a } = e, { labelProps: i, fieldProps: o } = lc(e), u = Zr([
    !!t,
    !!r,
    n,
    a
  ]), c = Zr([
    !!t,
    !!r,
    n,
    a
  ]);
  return o = ne(o, {
    "aria-describedby": [
      u,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      c,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: i,
    fieldProps: o,
    descriptionProps: {
      id: u
    },
    errorMessageProps: {
      id: c
    }
  };
}
function sc(e, t) {
  let { inputElementType: r = "input", isDisabled: n = !1, isRequired: a = !1, isReadOnly: i = !1, type: o = "text", validationBehavior: u = "aria" } = e, [c, f] = br(e.value, e.defaultValue || "", e.onChange), { focusableProps: v } = Pr(e, t), m = Tn({
    ...e,
    value: c
  }), { isInvalid: p, validationErrors: y, validationDetails: C } = m.displayValidation, { labelProps: S, fieldProps: k, descriptionProps: D, errorMessageProps: P } = oc({
    ...e,
    isInvalid: p,
    errorMessage: e.errorMessage || y
  }), T = jt(e, {
    labelable: !0
  });
  const h = {
    type: o,
    pattern: e.pattern
  };
  return hr(t, c, f), tc(e, m, t), ee(() => {
    if (t.current instanceof Lt(t.current).HTMLTextAreaElement) {
      let w = t.current;
      Object.defineProperty(w, "defaultValue", {
        get: () => w.value,
        set: () => {
        },
        configurable: !0
      });
    }
  }, [
    t
  ]), {
    labelProps: S,
    inputProps: ne(T, r === "input" && h, {
      disabled: n,
      readOnly: i,
      required: a && u === "native",
      "aria-required": a && u === "aria" || void 0,
      "aria-invalid": p || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-activedescendant": e["aria-activedescendant"],
      "aria-autocomplete": e["aria-autocomplete"],
      "aria-haspopup": e["aria-haspopup"],
      value: c,
      onChange: (w) => f(w.target.value),
      autoComplete: e.autoComplete,
      maxLength: e.maxLength,
      minLength: e.minLength,
      name: e.name,
      placeholder: e.placeholder,
      inputMode: e.inputMode,
      // Clipboard events
      onCopy: e.onCopy,
      onCut: e.onCut,
      onPaste: e.onPaste,
      // Composition events
      onCompositionEnd: e.onCompositionEnd,
      onCompositionStart: e.onCompositionStart,
      onCompositionUpdate: e.onCompositionUpdate,
      // Selection events
      onSelect: e.onSelect,
      // Input events
      onBeforeInput: e.onBeforeInput,
      onInput: e.onInput,
      ...v,
      ...k
    }),
    descriptionProps: D,
    errorMessageProps: P,
    isInvalid: p,
    validationErrors: y,
    validationDetails: C
  };
}
function dn() {
  return typeof window < "u" && window.InputEvent && // @ts-ignore
  typeof InputEvent.prototype.getTargetRanges == "function";
}
function cc(e, t, r) {
  let n = Q((m) => {
    let p = r.current, y;
    switch (m.inputType) {
      case "historyUndo":
      case "historyRedo":
        return;
      case "deleteContent":
      case "deleteByCut":
      case "deleteByDrag":
        y = p.value.slice(0, p.selectionStart) + p.value.slice(p.selectionEnd);
        break;
      case "deleteContentForward":
        y = p.selectionEnd === p.selectionStart ? p.value.slice(0, p.selectionStart) + p.value.slice(p.selectionEnd + 1) : p.value.slice(0, p.selectionStart) + p.value.slice(p.selectionEnd);
        break;
      case "deleteContentBackward":
        y = p.selectionEnd === p.selectionStart ? p.value.slice(0, p.selectionStart - 1) + p.value.slice(p.selectionStart) : p.value.slice(0, p.selectionStart) + p.value.slice(p.selectionEnd);
        break;
      case "deleteSoftLineBackward":
      case "deleteHardLineBackward":
        y = p.value.slice(p.selectionStart);
        break;
      default:
        m.data != null && (y = p.value.slice(0, p.selectionStart) + m.data + p.value.slice(p.selectionEnd));
        break;
    }
    (y == null || !t.validate(y)) && m.preventDefault();
  });
  ee(() => {
    if (!dn())
      return;
    let m = r.current;
    return m.addEventListener("beforeinput", n, !1), () => {
      m.removeEventListener("beforeinput", n, !1);
    };
  }, [
    r,
    n
  ]);
  let a = dn() ? null : (m) => {
    let p = m.target.value.slice(0, m.target.selectionStart) + m.data + m.target.value.slice(m.target.selectionEnd);
    t.validate(p) || m.preventDefault();
  }, { labelProps: i, inputProps: o, descriptionProps: u, errorMessageProps: c, ...f } = sc(e, r), v = Y(null);
  return {
    inputProps: ne(o, {
      onBeforeInput: a,
      onCompositionStart() {
        let { value: m, selectionStart: p, selectionEnd: y } = r.current;
        v.current = {
          value: m,
          selectionStart: p,
          selectionEnd: y
        };
      },
      onCompositionEnd() {
        if (!t.validate(r.current.value)) {
          let { value: m, selectionStart: p, selectionEnd: y } = v.current;
          r.current.value = m, r.current.setSelectionRange(p, y), t.setInputValue(m);
        }
      }
    }),
    labelProps: i,
    descriptionProps: u,
    errorMessageProps: c,
    ...f
  };
}
function uc(e) {
  return e && e.__esModule ? e.default : e;
}
var Gn = {}, Zn = {};
Zn = {
  Empty: "فارغ"
};
var Jn = {};
Jn = {
  Empty: "Изпразни"
};
var Xn = {};
Xn = {
  Empty: "Prázdné"
};
var Qn = {};
Qn = {
  Empty: "Tom"
};
var ea = {};
ea = {
  Empty: "Leer"
};
var ta = {};
ta = {
  Empty: "Άδειο"
};
var ra = {};
ra = {
  Empty: "Empty"
};
var na = {};
na = {
  Empty: "Vacío"
};
var aa = {};
aa = {
  Empty: "Tühjenda"
};
var ia = {};
ia = {
  Empty: "Tyhjä"
};
var la = {};
la = {
  Empty: "Vide"
};
var oa = {};
oa = {
  Empty: "ריק"
};
var sa = {};
sa = {
  Empty: "Prazno"
};
var ca = {};
ca = {
  Empty: "Üres"
};
var ua = {};
ua = {
  Empty: "Vuoto"
};
var da = {};
da = {
  Empty: "空"
};
var fa = {};
fa = {
  Empty: "비어 있음"
};
var pa = {};
pa = {
  Empty: "Tuščias"
};
var ba = {};
ba = {
  Empty: "Tukšs"
};
var ma = {};
ma = {
  Empty: "Tom"
};
var va = {};
va = {
  Empty: "Leeg"
};
var ga = {};
ga = {
  Empty: "Pusty"
};
var ha = {};
ha = {
  Empty: "Vazio"
};
var _a = {};
_a = {
  Empty: "Vazio"
};
var $a = {};
$a = {
  Empty: "Gol"
};
var ya = {};
ya = {
  Empty: "Не заполнено"
};
var xa = {};
xa = {
  Empty: "Prázdne"
};
var Pa = {};
Pa = {
  Empty: "Prazen"
};
var wa = {};
wa = {
  Empty: "Prazno"
};
var Ea = {};
Ea = {
  Empty: "Tomt"
};
var Sa = {};
Sa = {
  Empty: "Boş"
};
var Ta = {};
Ta = {
  Empty: "Пусто"
};
var Ca = {};
Ca = {
  Empty: "空"
};
var ka = {};
ka = {
  Empty: "空白"
};
Gn = {
  "ar-AE": Zn,
  "bg-BG": Jn,
  "cs-CZ": Xn,
  "da-DK": Qn,
  "de-DE": ea,
  "el-GR": ta,
  "en-US": ra,
  "es-ES": na,
  "et-EE": aa,
  "fi-FI": ia,
  "fr-FR": la,
  "he-IL": oa,
  "hr-HR": sa,
  "hu-HU": ca,
  "it-IT": ua,
  "ja-JP": da,
  "ko-KR": fa,
  "lt-LT": pa,
  "lv-LV": ba,
  "nb-NO": ma,
  "nl-NL": va,
  "pl-PL": ga,
  "pt-BR": ha,
  "pt-PT": _a,
  "ro-RO": $a,
  "ru-RU": ya,
  "sk-SK": xa,
  "sl-SI": Pa,
  "sr-SP": wa,
  "sv-SE": Ea,
  "tr-TR": Sa,
  "uk-UA": Ta,
  "zh-CN": Ca,
  "zh-TW": ka
};
function dc(e) {
  const t = Y();
  let { value: r, textValue: n, minValue: a, maxValue: i, isDisabled: o, isReadOnly: u, isRequired: c, onIncrement: f, onIncrementPage: v, onDecrement: m, onDecrementPage: p, onDecrementToMin: y, onIncrementToMax: C } = e;
  const S = qn(/* @__PURE__ */ uc(Gn)), k = () => clearTimeout(t.current);
  ee(() => () => k(), []);
  let D = ($) => {
    if (!($.ctrlKey || $.metaKey || $.shiftKey || $.altKey || u))
      switch ($.key) {
        case "PageUp":
          if (v) {
            $.preventDefault(), v();
            break;
          }
        case "ArrowUp":
        case "Up":
          f && ($.preventDefault(), f());
          break;
        case "PageDown":
          if (p) {
            $.preventDefault(), p();
            break;
          }
        case "ArrowDown":
        case "Down":
          m && ($.preventDefault(), m());
          break;
        case "Home":
          y && ($.preventDefault(), y());
          break;
        case "End":
          C && ($.preventDefault(), C());
          break;
      }
  }, P = Y(!1), T = () => {
    P.current = !0;
  }, h = () => {
    P.current = !1;
  };
  n = n === "" ? S.format("Empty") : (n || `${r}`).replace("-", "−"), ee(() => {
    P.current && (Qs("assertive"), Xs(n, "assertive"));
  }, [
    n
  ]);
  const w = Q(($) => {
    k(), f(), t.current = window.setTimeout(() => {
      (isNaN(i) || isNaN(r) || r < i) && w(60);
    }, $);
  }), M = Q(($) => {
    k(), m(), t.current = window.setTimeout(() => {
      (isNaN(a) || isNaN(r) || r > a) && M(60);
    }, $);
  });
  let j = ($) => {
    $.preventDefault();
  }, { addGlobalListener: s, removeAllGlobalListeners: L } = Mn();
  return {
    spinButtonProps: {
      role: "spinbutton",
      "aria-valuenow": isNaN(r) ? null : r,
      "aria-valuetext": n,
      "aria-valuemin": a,
      "aria-valuemax": i,
      "aria-disabled": o || null,
      "aria-readonly": u || null,
      "aria-required": c || null,
      onKeyDown: D,
      onFocus: T,
      onBlur: h
    },
    incrementButtonProps: {
      onPressStart: () => {
        w(400), s(window, "contextmenu", j);
      },
      onPressEnd: () => {
        k(), L();
      },
      onFocus: T,
      onBlur: h
    },
    decrementButtonProps: {
      onPressStart: () => {
        M(400), s(window, "contextmenu", j);
      },
      onPressEnd: () => {
        k(), L();
      },
      onFocus: T,
      onBlur: h
    }
  };
}
function fc(e) {
  return e && e.__esModule ? e.default : e;
}
var La = {}, Da = {};
Da = {
  decrease: (e) => `خفض ${e.fieldLabel}`,
  increase: (e) => `زيادة ${e.fieldLabel}`,
  numberField: "حقل رقمي"
};
var Fa = {};
Fa = {
  decrease: (e) => `Намаляване ${e.fieldLabel}`,
  increase: (e) => `Усилване ${e.fieldLabel}`,
  numberField: "Номер на полето"
};
var ja = {};
ja = {
  decrease: (e) => `Snížit ${e.fieldLabel}`,
  increase: (e) => `Zvýšit ${e.fieldLabel}`,
  numberField: "Číselné pole"
};
var Ia = {};
Ia = {
  decrease: (e) => `Reducer ${e.fieldLabel}`,
  increase: (e) => `Øg ${e.fieldLabel}`,
  numberField: "Talfelt"
};
var Na = {};
Na = {
  decrease: (e) => `${e.fieldLabel} verringern`,
  increase: (e) => `${e.fieldLabel} erhöhen`,
  numberField: "Nummernfeld"
};
var Ra = {};
Ra = {
  decrease: (e) => `Μείωση ${e.fieldLabel}`,
  increase: (e) => `Αύξηση ${e.fieldLabel}`,
  numberField: "Πεδίο αριθμού"
};
var Ma = {};
Ma = {
  decrease: (e) => `Decrease ${e.fieldLabel}`,
  increase: (e) => `Increase ${e.fieldLabel}`,
  numberField: "Number field"
};
var Va = {};
Va = {
  decrease: (e) => `Reducir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo de número"
};
var Oa = {};
Oa = {
  decrease: (e) => `Vähenda ${e.fieldLabel}`,
  increase: (e) => `Suurenda ${e.fieldLabel}`,
  numberField: "Numbri väli"
};
var Aa = {};
Aa = {
  decrease: (e) => `Vähennä ${e.fieldLabel}`,
  increase: (e) => `Lisää ${e.fieldLabel}`,
  numberField: "Numerokenttä"
};
var Ba = {};
Ba = {
  decrease: (e) => `Diminuer ${e.fieldLabel}`,
  increase: (e) => `Augmenter ${e.fieldLabel}`,
  numberField: "Champ de nombre"
};
var za = {};
za = {
  decrease: (e) => `הקטן ${e.fieldLabel}`,
  increase: (e) => `הגדל ${e.fieldLabel}`,
  numberField: "שדה מספר"
};
var Ka = {};
Ka = {
  decrease: (e) => `Smanji ${e.fieldLabel}`,
  increase: (e) => `Povećaj ${e.fieldLabel}`,
  numberField: "Polje broja"
};
var Ua = {};
Ua = {
  decrease: (e) => `${e.fieldLabel} csökkentése`,
  increase: (e) => `${e.fieldLabel} növelése`,
  numberField: "Számmező"
};
var Wa = {};
Wa = {
  decrease: (e) => `Riduci ${e.fieldLabel}`,
  increase: (e) => `Aumenta ${e.fieldLabel}`,
  numberField: "Campo numero"
};
var Ha = {};
Ha = {
  decrease: (e) => `${e.fieldLabel}を縮小`,
  increase: (e) => `${e.fieldLabel}を拡大`,
  numberField: "数値フィールド"
};
var qa = {};
qa = {
  decrease: (e) => `${e.fieldLabel} 감소`,
  increase: (e) => `${e.fieldLabel} 증가`,
  numberField: "번호 필드"
};
var Ya = {};
Ya = {
  decrease: (e) => `Sumažinti ${e.fieldLabel}`,
  increase: (e) => `Padidinti ${e.fieldLabel}`,
  numberField: "Numerio laukas"
};
var Ga = {};
Ga = {
  decrease: (e) => `Samazināšana ${e.fieldLabel}`,
  increase: (e) => `Palielināšana ${e.fieldLabel}`,
  numberField: "Skaitļu lauks"
};
var Za = {};
Za = {
  decrease: (e) => `Reduser ${e.fieldLabel}`,
  increase: (e) => `Øk ${e.fieldLabel}`,
  numberField: "Tallfelt"
};
var Ja = {};
Ja = {
  decrease: (e) => `${e.fieldLabel} verlagen`,
  increase: (e) => `${e.fieldLabel} verhogen`,
  numberField: "Getalveld"
};
var Xa = {};
Xa = {
  decrease: (e) => `Zmniejsz ${e.fieldLabel}`,
  increase: (e) => `Zwiększ ${e.fieldLabel}`,
  numberField: "Pole numeru"
};
var Qa = {};
Qa = {
  decrease: (e) => `Diminuir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo de número"
};
var ei = {};
ei = {
  decrease: (e) => `Diminuir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo numérico"
};
var ti = {};
ti = {
  decrease: (e) => `Scădere ${e.fieldLabel}`,
  increase: (e) => `Creștere ${e.fieldLabel}`,
  numberField: "Câmp numeric"
};
var ri = {};
ri = {
  decrease: (e) => `Уменьшение ${e.fieldLabel}`,
  increase: (e) => `Увеличение ${e.fieldLabel}`,
  numberField: "Числовое поле"
};
var ni = {};
ni = {
  decrease: (e) => `Znížiť ${e.fieldLabel}`,
  increase: (e) => `Zvýšiť ${e.fieldLabel}`,
  numberField: "Číselné pole"
};
var ai = {};
ai = {
  decrease: (e) => `Upadati ${e.fieldLabel}`,
  increase: (e) => `Povečajte ${e.fieldLabel}`,
  numberField: "Številčno polje"
};
var ii = {};
ii = {
  decrease: (e) => `Smanji ${e.fieldLabel}`,
  increase: (e) => `Povećaj ${e.fieldLabel}`,
  numberField: "Polje broja"
};
var li = {};
li = {
  decrease: (e) => `Minska ${e.fieldLabel}`,
  increase: (e) => `Öka ${e.fieldLabel}`,
  numberField: "Nummerfält"
};
var oi = {};
oi = {
  decrease: (e) => `${e.fieldLabel} azalt`,
  increase: (e) => `${e.fieldLabel} arttır`,
  numberField: "Sayı alanı"
};
var si = {};
si = {
  decrease: (e) => `Зменшити ${e.fieldLabel}`,
  increase: (e) => `Збільшити ${e.fieldLabel}`,
  numberField: "Поле номера"
};
var ci = {};
ci = {
  decrease: (e) => `降低 ${e.fieldLabel}`,
  increase: (e) => `提高 ${e.fieldLabel}`,
  numberField: "数字字段"
};
var ui = {};
ui = {
  decrease: (e) => `縮小 ${e.fieldLabel}`,
  increase: (e) => `放大 ${e.fieldLabel}`,
  numberField: "數字欄位"
};
La = {
  "ar-AE": Da,
  "bg-BG": Fa,
  "cs-CZ": ja,
  "da-DK": Ia,
  "de-DE": Na,
  "el-GR": Ra,
  "en-US": Ma,
  "es-ES": Va,
  "et-EE": Oa,
  "fi-FI": Aa,
  "fr-FR": Ba,
  "he-IL": za,
  "hr-HR": Ka,
  "hu-HU": Ua,
  "it-IT": Wa,
  "ja-JP": Ha,
  "ko-KR": qa,
  "lt-LT": Ya,
  "lv-LV": Ga,
  "nb-NO": Za,
  "nl-NL": Ja,
  "pl-PL": Xa,
  "pt-BR": Qa,
  "pt-PT": ei,
  "ro-RO": ti,
  "ru-RU": ri,
  "sk-SK": ni,
  "sl-SI": ai,
  "sr-SP": ii,
  "sv-SE": li,
  "tr-TR": oi,
  "uk-UA": si,
  "zh-CN": ci,
  "zh-TW": ui
};
function pc(e, t, r) {
  let { id: n, decrementAriaLabel: a, incrementAriaLabel: i, isDisabled: o, isReadOnly: u, isRequired: c, minValue: f, maxValue: v, autoFocus: m, label: p, formatOptions: y, onBlur: C = () => {
  }, onFocus: S, onFocusChange: k, onKeyDown: D, onKeyUp: P, description: T, errorMessage: h, ...w } = e, { increment: M, incrementToMax: j, decrement: s, decrementToMin: L, numberValue: $, inputValue: x, commit: I, commitValidation: b } = t;
  const _ = qn(/* @__PURE__ */ fc(La));
  let V = Ie(n), { focusProps: Z } = yr({
    onBlur() {
      I();
    }
  }), oe = un(y), te = U(() => oe.resolvedOptions(), [
    oe
  ]), ae = un({
    ...y,
    currencySign: void 0
  }), fe = U(() => isNaN($) ? "" : ae.format($), [
    ae,
    $
  ]), { spinButtonProps: se, incrementButtonProps: O, decrementButtonProps: pe } = dc({
    isDisabled: o,
    isReadOnly: u,
    isRequired: c,
    maxValue: v,
    minValue: f,
    onIncrement: M,
    onIncrementToMax: j,
    onDecrement: s,
    onDecrementToMin: L,
    value: $,
    textValue: fe
  }), [ce, ue] = G(!1), { focusWithinProps: ve } = Un({
    isDisabled: o,
    onFocusWithinChange: ue
  }), Pe = W((J) => {
    Math.abs(J.deltaY) <= Math.abs(J.deltaX) || (J.deltaY > 0 ? M() : J.deltaY < 0 && s());
  }, [
    s,
    M
  ]);
  Os({
    onScroll: Pe,
    isDisabled: o || u || !ce
  }, r);
  let Ve = te.maximumFractionDigits > 0, ke = isNaN(t.minValue) || t.minValue < 0, Le = "numeric";
  In() ? ke ? Le = "text" : Ve && (Le = "decimal") : gr() && (ke ? Le = "numeric" : Ve && (Le = "decimal"));
  let dt = (J) => {
    t.validate(J) && t.setInputValue(J);
  }, Rt = jt(e), ft = W((J) => {
    J.key === "Enter" ? (I(), b()) : J.continuePropagation();
  }, [
    I,
    b
  ]), { isInvalid: De, validationErrors: Oe, validationDetails: pt } = t.displayValidation, { labelProps: Xe, inputProps: Ae, descriptionProps: Mt, errorMessageProps: Vt } = cc({
    ...w,
    ...Rt,
    name: void 0,
    label: p,
    autoFocus: m,
    isDisabled: o,
    isReadOnly: u,
    isRequired: c,
    validate: void 0,
    [ar]: t,
    value: x,
    defaultValue: void 0,
    autoComplete: "off",
    "aria-label": e["aria-label"] || null,
    "aria-labelledby": e["aria-labelledby"] || null,
    id: V,
    type: "text",
    inputMode: Le,
    onChange: dt,
    onBlur: C,
    onFocus: S,
    onFocusChange: k,
    onKeyDown: U(() => jn(ft, D), [
      ft,
      D
    ]),
    onKeyUp: P,
    description: T,
    errorMessage: h
  }, t, r);
  hr(r, t.numberValue, t.setNumberValue);
  let Be = ne(se, Z, Ae, {
    // override the spinbutton role, we can't focus a spin button with VO
    role: null,
    // ignore aria-roledescription on iOS so that required state will announce when it is present
    "aria-roledescription": vr() ? null : _.format("numberField"),
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null,
    autoCorrect: "off",
    spellCheck: "false"
  });
  e.validationBehavior === "native" && (Be["aria-required"] = void 0);
  let bt = (J) => {
    document.activeElement !== r.current && (J.pointerType === "mouse" ? r.current.focus() : J.target.focus());
  }, Qe = e["aria-label"] || (typeof e.label == "string" ? e.label : ""), be;
  Qe || (be = e.label != null ? Xe.id : e["aria-labelledby"]);
  let et = Ie(), we = Ie(), Ot = ne(O, {
    "aria-label": i || _.format("increase", {
      fieldLabel: Qe
    }).trim(),
    id: be && !i ? et : null,
    "aria-labelledby": be && !i ? `${et} ${be}` : null,
    "aria-controls": V,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !t.canIncrement,
    onPressStart: bt
  }), mt = ne(pe, {
    "aria-label": a || _.format("decrease", {
      fieldLabel: Qe
    }).trim(),
    id: be && !a ? we : null,
    "aria-labelledby": be && !a ? `${we} ${be}` : null,
    "aria-controls": V,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !t.canDecrement,
    onPressStart: bt
  });
  return {
    groupProps: {
      ...ve,
      role: "group",
      "aria-disabled": o,
      "aria-invalid": De ? "true" : void 0
    },
    labelProps: Xe,
    inputProps: Be,
    incrementButtonProps: Ot,
    decrementButtonProps: mt,
    errorMessageProps: Vt,
    descriptionProps: Mt,
    isInvalid: De,
    validationErrors: Oe,
    validationDetails: pt
  };
}
function bc(e, t, r) {
  let { inputProps: n, isSelected: a, isPressed: i, isDisabled: o, isReadOnly: u } = ic(e, t, r);
  return {
    inputProps: {
      ...n,
      role: "switch",
      checked: a
    },
    isSelected: a,
    isPressed: i,
    isDisabled: o,
    isReadOnly: u
  };
}
const mc = "_stepper_1av3q_1", vc = "_button_1av3q_18", gc = "_input_1av3q_45", wt = {
  stepper: mc,
  "stepper--block": "_stepper--block_1av3q_10",
  button: vc,
  input: gc
};
function fn(e) {
  const t = Y(null), { buttonProps: r } = Js(e, t);
  return /* @__PURE__ */ d.jsx("button", { ...r, ref: t, className: wt.button, children: e.children });
}
function hc({
  block: e,
  className: t,
  decrementAriaLabel: r,
  description: n,
  disabled: a,
  incrementAriaLabel: i,
  inputClassName: o,
  inputProps: u,
  label: c,
  labelClassName: f,
  labelRef: v,
  max: m,
  min: p,
  name: y,
  ...C
}, S) {
  const k = {
    minValue: p,
    maxValue: m,
    label: c,
    description: n,
    isDisabled: a,
    ...C
  }, { locale: D } = wr(), P = Uo({ ...k, locale: D }), T = Y(null), {
    groupProps: h,
    labelProps: w,
    descriptionProps: M,
    inputProps: j,
    incrementButtonProps: s,
    decrementButtonProps: L
  } = pc(k, P, T);
  let $ = null;
  return c && ($ = /* @__PURE__ */ d.jsxs("div", { children: [
    /* @__PURE__ */ d.jsx(ut, { ...w, block: !0, className: f, ref: v, children: c }),
    typeof n < "u" && /* @__PURE__ */ d.jsx(ct, { ...M, children: n })
  ] })), r && (L["aria-label"] = r), i && (L["aria-label"] = i), /* @__PURE__ */ d.jsxs(Ze, { direction: "column", gap: "0.5rem", ref: S, className: t, children: [
    $,
    /* @__PURE__ */ d.jsxs(
      "div",
      {
        ...h,
        className: F(wt.stepper, e && wt["stepper--block"]),
        children: [
          /* @__PURE__ */ d.jsx(fn, { ...L, children: /* @__PURE__ */ d.jsx("svg", { viewBox: "0 0 24 24", width: "24", height: "24", "aria-hidden": !0, children: /* @__PURE__ */ d.jsx("rect", { x: "5", y: "11", width: "14", height: "2" }) }) }),
          /* @__PURE__ */ d.jsx(
            "input",
            {
              ...j,
              ...u,
              ref: T,
              className: F(wt.input, o)
            }
          ),
          /* @__PURE__ */ d.jsx(fn, { ...s, children: /* @__PURE__ */ d.jsxs("svg", { viewBox: "0 0 24 24", width: "24", height: "24", "aria-hidden": !0, children: [
            /* @__PURE__ */ d.jsx("rect", { x: "5", y: "11", width: "14", height: "2" }),
            /* @__PURE__ */ d.jsx("rect", { x: "11", y: "5", width: "2", height: "14" })
          ] }) })
        ]
      }
    ),
    y && /* @__PURE__ */ d.jsx(
      "input",
      {
        type: "hidden",
        name: y,
        value: isNaN(P.numberValue) ? "" : P.numberValue
      }
    )
  ] });
}
const $u = /* @__PURE__ */ z(
  hc
), _c = "_radio__input_1sjc3_1", $c = "_radio__label_1sjc3_6", pn = {
  radio__input: _c,
  radio__label: $c
}, di = Dt(
  null
);
function yc({
  checked: e,
  className: t,
  defaultChecked: r,
  disabled: n = !1,
  id: a,
  innerRef: i,
  inputClassName: o,
  inputProps: u = {},
  inputRef: c,
  label: f,
  labelClassName: v,
  labelProps: m = {},
  labelRef: p,
  name: y,
  onBlur: C,
  onChange: S,
  onFocus: k,
  value: D,
  ...P
}, T) {
  const h = me(di), w = W(
    (L) => {
      S && S(L), h != null && h.onChange && h.onChange(L);
    },
    [S, h == null ? void 0 : h.onChange]
  ), M = `radio-${Ce()}`, j = a ?? M;
  let s = e;
  return h && (s = h.value === D), /* @__PURE__ */ d.jsxs(
    "div",
    {
      ...P,
      ref: T ?? i,
      className: t,
      onClick: (L) => {
        L.target.localName === "input" && L.target.focus(), typeof P.onClick == "function" && P.onClick(L);
      },
      children: [
        /* @__PURE__ */ d.jsx(
          "input",
          {
            ...u,
            checked: s,
            className: F(pn.radio__input, o),
            defaultChecked: r,
            disabled: n,
            id: j,
            name: y ?? (h == null ? void 0 : h.name),
            onBlur: C,
            onChange: w,
            onFocus: k,
            ref: c,
            type: "radio",
            value: D
          }
        ),
        /* @__PURE__ */ d.jsx(
          "label",
          {
            ...m,
            htmlFor: j,
            ref: p,
            className: F(pn.radio__label, v),
            children: f
          }
        )
      ]
    }
  );
}
const yu = /* @__PURE__ */ z(yc), bn = {
  "radio-group--row": "_radio-group--row_6ppsz_1"
};
function xu({
  children: e,
  description: t,
  label: r,
  message: n,
  name: a,
  onChange: i,
  row: o,
  secondaryLabel: u,
  supplemental: c,
  tone: f,
  value: v,
  ...m
}) {
  const p = Ce(), y = `label-${p}`, C = `description-${p}`, S = `message-${p}`, k = W(
    (T) => {
      i && i(T.currentTarget.value);
    },
    [i]
  ), D = U(
    () => ({
      name: a,
      onChange: k,
      value: v ?? ""
    }),
    [a, k, v]
  );
  let P;
  return (n || t) && (P = [t && C, n && S].filter(Boolean).join(" ")), /* @__PURE__ */ d.jsxs(Ze, { ...m, direction: "column", gap: "0.5rem", children: [
    r && /* @__PURE__ */ d.jsxs("div", { children: [
      /* @__PURE__ */ d.jsx(
        ut,
        {
          block: !0,
          id: y,
          secondaryLabel: t ? void 0 : u,
          children: r
        }
      ),
      typeof t < "u" && /* @__PURE__ */ d.jsx(ct, { id: C, children: t })
    ] }),
    c,
    /* @__PURE__ */ d.jsx(di.Provider, { value: D, children: /* @__PURE__ */ d.jsx(
      "div",
      {
        role: "radiogroup",
        "aria-labelledby": y,
        "aria-describedby": P,
        "aria-invalid": f === "critical",
        className: F(
          bn["radio-group"],
          o && bn["radio-group--row"]
        ),
        children: e
      }
    ) }),
    n && /* @__PURE__ */ d.jsx(Ft, { id: S, tone: f, children: n })
  ] });
}
const xc = "_select_1l1da_1", Pc = "_select__input_1l1da_33", wc = "_select_icon_1l1da_69", $e = {
  select: xc,
  "select--block": "_select--block_1l1da_14",
  "select--disabled": "_select--disabled_1l1da_18",
  "select--invalid": "_select--invalid_1l1da_21",
  "select--large": "_select--large_1l1da_24",
  "select--small": "_select--small_1l1da_28",
  select__input: Pc,
  "select__input--large": "_select__input--large_1l1da_48",
  "select__input--small": "_select__input--small_1l1da_51",
  select_icon: wc,
  "select_icon--large": "_select_icon--large_1l1da_75",
  "select_icon--small": "_select_icon--small_1l1da_79"
}, Ec = "_icon_sslzs_1", Sc = {
  icon: Ec
};
function Tc({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsxs(
    "svg",
    {
      ...t,
      "aria-hidden": !0,
      className: F(Sc.icon, e),
      width: "0.75rem",
      height: "1.5rem",
      viewBox: "0 0 12 24",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ d.jsx(
          "polyline",
          {
            points: "3,9 6,6 9,9",
            fill: "none",
            stroke: "#1A1A1A",
            strokeWidth: "1.6"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "polyline",
          {
            points: "3,15 6,18 9,15",
            fill: "none",
            stroke: "#1A1A1A",
            strokeWidth: "1.6"
          }
        )
      ]
    }
  );
}
function Cc({
  "aria-describedby": e,
  "aria-labelledby": t,
  "aria-label": r,
  block: n = !1,
  className: a,
  children: i,
  defaultValue: o,
  disabled: u,
  id: c,
  innerRef: f,
  inputClassName: v,
  inputProps: m = {},
  inputRef: p,
  invalid: y = !1,
  name: C,
  onBlur: S,
  onChange: k,
  onFocus: D,
  size: P,
  value: T,
  ...h
}, w) {
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      ...h,
      className: F(
        $e.select,
        P && $e[`select--${P}`],
        n && $e["select--block"],
        u && $e["select--disabled"],
        y && $e["select--invalid"],
        a
      ),
      ref: w ?? f,
      children: [
        /* @__PURE__ */ d.jsx(
          "select",
          {
            ...m,
            "aria-describedby": e,
            "aria-labelledby": t,
            "aria-label": r,
            "aria-invalid": y ? !0 : void 0,
            className: F(
              $e.select__input,
              P && $e[`select__input--${P}`],
              v
            ),
            defaultValue: o,
            disabled: u,
            id: c,
            name: C,
            onBlur: S,
            onChange: k,
            onFocus: D,
            ref: p,
            value: T,
            children: i
          }
        ),
        /* @__PURE__ */ d.jsx(
          Tc,
          {
            className: F(
              $e.select_icon,
              P && $e[`select_icon--${P}`]
            )
          }
        )
      ]
    }
  );
}
const kc = /* @__PURE__ */ z(Cc), Lc = "_selectfield__input_xfgts_6", mn = {
  "selectfield--block": "_selectfield--block_xfgts_1",
  selectfield__input: Lc
};
function Dc({
  block: e = !1,
  children: t,
  className: r,
  defaultValue: n,
  description: a,
  disabled: i = !1,
  id: o,
  innerRef: u,
  inputClassName: c,
  inputProps: f = {},
  inputRef: v,
  label: m,
  labelClassName: p,
  labelProps: y = {},
  labelRef: C,
  message: S,
  messageClassName: k,
  messageProps: D = {},
  messageRef: P,
  name: T,
  onBlur: h,
  onChange: w,
  onFocus: M,
  secondaryLabel: j,
  size: s,
  supplemental: L,
  tone: $,
  value: x,
  ...I
}, b) {
  const _ = Ce(), V = y.id || `label-${_}`, Z = `description-${_}`, oe = o || `select-${_}`, te = D.id || `message-${_}`;
  let ae = null;
  m && (ae = /* @__PURE__ */ d.jsxs("div", { children: [
    /* @__PURE__ */ d.jsx(
      ut,
      {
        ...y,
        block: !0,
        className: p,
        id: V,
        ref: C,
        htmlFor: oe,
        secondaryLabel: a ? void 0 : j,
        children: m
      }
    ),
    typeof a < "u" && /* @__PURE__ */ d.jsx(ct, { id: Z, children: a })
  ] }));
  const fe = U(() => {
    if (!(!S && !a))
      return [a && Z, S && te].filter(Boolean).join(" ");
  }, [a, Z, S, te]), se = /* @__PURE__ */ d.jsx(
    kc,
    {
      ...f,
      "aria-describedby": fe,
      "aria-labelledby": m ? V : void 0,
      block: e,
      defaultValue: n,
      disabled: i,
      id: oe,
      inputClassName: F(mn.selectfield__input, c),
      invalid: $ === "critical",
      name: T,
      onBlur: h,
      onChange: w,
      onFocus: M,
      ref: v,
      size: s,
      value: x,
      children: t
    }
  );
  let O = null;
  return S && (O = /* @__PURE__ */ d.jsx(
    Ft,
    {
      ...D,
      className: k,
      id: te,
      ref: P,
      tone: $,
      children: S
    }
  )), /* @__PURE__ */ d.jsxs(
    Ze,
    {
      ...I,
      direction: "column",
      gap: "0.5rem",
      className: F(e && mn["selectfield--block"], r),
      ref: b ?? u,
      children: [
        ae,
        L,
        se,
        O
      ]
    }
  );
}
const Pu = /* @__PURE__ */ z(
  Dc
), Fc = "_visuallyHidden_dwm1g_1", jc = {
  visuallyHidden: Fc
};
function Ic(e, t) {
  return /* @__PURE__ */ d.jsx("span", { ...e, className: jc.visuallyHidden, ref: t });
}
const Nc = /* @__PURE__ */ z(
  Ic
), Rc = "_root_142yz_5", Mc = "_label_142yz_9", Vc = "_thumb_142yz_13", Oc = "_focused_142yz_21", Ac = "_pressed_142yz_25", Bc = "_thumb__circle_142yz_25", zc = "_thumb__rect_142yz_29", Kc = "_checked_142yz_33", ye = {
  root: Rc,
  label: Mc,
  thumb: Vc,
  focused: Oc,
  pressed: Ac,
  thumb__circle: Bc,
  thumb__rect: zc,
  checked: Kc
};
function Uc(e, t) {
  const {
    autoFocus: r,
    checked: n,
    children: a,
    defaultChecked: i,
    disabled: o,
    name: u,
    onBlur: c,
    onChange: f,
    onFocus: v,
    value: m,
    ...p
  } = e, y = Y(null), C = Wo({
    autoFocus: r,
    onBlur: c,
    onChange: f,
    onFocus: v,
    value: m,
    // React ARIA-specific naming conventions
    defaultSelected: i,
    isDisabled: o,
    isSelected: n
  }), {
    inputProps: S,
    isDisabled: k,
    isSelected: D
  } = bc(e, C, y), { isFocusVisible: P, focusProps: T } = zs(), [h, w] = G(!1), { pressProps: M } = _r({
    isDisabled: k,
    onPressStart(s) {
      s.pointerType !== "keyboard" && w(!0);
    },
    onPressEnd(s) {
      s.pointerType !== "keyboard" && w(!1);
    }
  }), { keyboardProps: j } = Wn({
    onKeyUp(s) {
      s.key === "Enter" && C.toggle();
    }
  });
  return /* @__PURE__ */ d.jsxs(
    "label",
    {
      ...p,
      ...M,
      className: F(
        ye.root,
        P && ye.focused,
        h && ye.pressed,
        k && ye.disabled,
        D && ye.checked,
        p.className
      ),
      ref: t,
      children: [
        /* @__PURE__ */ d.jsx(Nc, { children: /* @__PURE__ */ d.jsx(
          "input",
          {
            name: u,
            ...ne(S, T, j),
            ref: y
          }
        ) }),
        a
      ]
    }
  );
}
const fi = /* @__PURE__ */ z(
  Uc
);
function pi({
  children: e,
  className: t,
  ...r
}) {
  return /* @__PURE__ */ d.jsx("span", { ...r, className: F(ye.label, t), children: e });
}
function bi({ className: e }) {
  return /* @__PURE__ */ d.jsxs(
    "svg",
    {
      "aria-hidden": !0,
      viewBox: "0 0 40 24",
      width: 40,
      height: 24,
      className: F(ye.thumb, e),
      children: [
        /* @__PURE__ */ d.jsx(
          "rect",
          {
            x: 0,
            y: 0,
            width: 40,
            height: 24,
            rx: 12,
            className: ye.thumb__rect
          }
        ),
        /* @__PURE__ */ d.jsx("circle", { cx: 12, cy: 12, r: 10, className: ye.thumb__circle })
      ]
    }
  );
}
function Wc({ children: e, ...t }) {
  return /* @__PURE__ */ d.jsx(fi, { ...t, children: /* @__PURE__ */ d.jsxs(Ze, { align: "center", gap: "0.75rem", justify: "space-between", children: [
    /* @__PURE__ */ d.jsx(pi, { children: e }),
    /* @__PURE__ */ d.jsx(bi, {})
  ] }) });
}
const Er = Wc;
Er.Root = fi;
Er.Label = pi;
Er.Thumb = bi;
const Hc = "_prose_5kq9l_1", qc = {
  prose: Hc
};
function wu({ as: e = "div", className: t, ...r }) {
  return gn(e, {
    ...r,
    className: F(qc.prose, t)
  });
}
const Yc = "_text_1hhgz_5", qe = {
  text: Yc,
  "text--display": "_text--display_1hhgz_47",
  "text--h1": "_text--h1_1hhgz_53",
  "text--h2": "_text--h2_1hhgz_59",
  "text--h3": "_text--h3_1hhgz_65",
  "text--lead": "_text--lead_1hhgz_71",
  "text--paragraph": "_text--paragraph_1hhgz_77",
  "text--base": "_text--base_1hhgz_83",
  "text--caption": "_text--caption_1hhgz_89",
  "text--fineprint": "_text--fineprint_1hhgz_95",
  "text--mb": "_text--mb_1hhgz_101",
  "text--mt": "_text--mt_1hhgz_105",
  "text--mb-0x": "_text--mb-0x_1hhgz_109",
  "text--mb-0.5x": "_text--mb-0.5x_1hhgz_113",
  "text--mb-1x": "_text--mb-1x_1hhgz_117",
  "text--mb-2x": "_text--mb-2x_1hhgz_121",
  "text--mb-3x": "_text--mb-3x_1hhgz_125",
  "text--mb-4x": "_text--mb-4x_1hhgz_129",
  "text--mb-6x": "_text--mb-6x_1hhgz_133",
  "text--mb-8x": "_text--mb-8x_1hhgz_137",
  "text--mb-10x": "_text--mb-10x_1hhgz_141",
  "text--mt-0x": "_text--mt-0x_1hhgz_145",
  "text--mt-0.5x": "_text--mt-0.5x_1hhgz_149",
  "text--mt-1x": "_text--mt-1x_1hhgz_153",
  "text--mt-2x": "_text--mt-2x_1hhgz_157",
  "text--mt-3x": "_text--mt-3x_1hhgz_161",
  "text--mt-4x": "_text--mt-4x_1hhgz_165",
  "text--mt-6x": "_text--mt-6x_1hhgz_169",
  "text--mt-8x": "_text--mt-8x_1hhgz_173",
  "text--mt-10x": "_text--mt-10x_1hhgz_177"
}, Gc = {
  h1: "h1",
  h2: "h2",
  h3: "h3"
};
function Zc({
  as: e = "p",
  children: t,
  className: r,
  mb: n,
  mt: a,
  size: i = Gc[e],
  ...o
}, u) {
  return gn(
    e,
    {
      ...o,
      ref: u,
      className: F(
        qe.text,
        i && qe[`text--${i}`],
        n && qe["text--mb"],
        n && qe[`text--mb-${n}`],
        a && qe["text--mt"],
        a && qe[`text--mt-${a}`],
        r
      )
    },
    t
  );
}
const Jc = /* @__PURE__ */ z(Zc);
function xe(e, t, r) {
  function n(a) {
    return /* @__PURE__ */ d.jsx(Jc, { as: e, size: t, ...a });
  }
  return n.displayName = r, n;
}
const Eu = /* @__PURE__ */ xe("h1", "display", "Display"), Su = /* @__PURE__ */ xe("h1", "h1", "H1"), Tu = /* @__PURE__ */ xe("h2", "h2", "H2"), Cu = /* @__PURE__ */ xe("h3", "h3", "H3"), ku = /* @__PURE__ */ xe("p", "lead", "Lead"), Lu = /* @__PURE__ */ xe(
  "p",
  "paragraph",
  "Paragraph"
), Du = /* @__PURE__ */ xe("p", "base", "Base"), Fu = /* @__PURE__ */ xe("p", "caption", "Caption"), ju = /* @__PURE__ */ xe(
  "p",
  "fineprint",
  "Fineprint"
), Xc = "_textarea_te4tc_1", at = {
  textarea: Xc,
  "textarea--resizeable": "_textarea--resizeable_te4tc_26",
  "textarea--resizeable-both": "_textarea--resizeable-both_te4tc_26",
  "textarea--resizeable-vertical": "_textarea--resizeable-vertical_te4tc_29",
  "textarea--resizeable-horizontal": "_textarea--resizeable-horizontal_te4tc_32",
  "textarea--block": "_textarea--block_te4tc_35",
  "textarea--invalid": "_textarea--invalid_te4tc_39"
};
function Qc({
  block: e = !1,
  invalid: t = !1,
  className: r,
  resizeable: n = !1,
  innerRef: a,
  ...i
}, o) {
  return /* @__PURE__ */ d.jsx(
    "textarea",
    {
      ...i,
      ref: o ?? a,
      className: F(
        at.textarea,
        e && at["textarea--block"],
        t && at["textarea--invalid"],
        n === !0 && at["textarea--resizeable"],
        typeof n == "string" && at[`textarea--resizeable-${n}`],
        r
      )
    }
  );
}
const eu = /* @__PURE__ */ z(Qc), tu = "_textfield__input_eid5i_6", vn = {
  "textfield--block": "_textfield--block_eid5i_1",
  textfield__input: tu
};
function ru({
  block: e = !1,
  className: t,
  defaultValue: r,
  description: n,
  disabled: a = !1,
  id: i,
  innerRef: o,
  inputClassName: u,
  inputProps: c = {},
  inputRef: f,
  label: v,
  labelClassName: m,
  labelProps: p = {},
  labelRef: y,
  message: C,
  messageClassName: S,
  messageProps: k = {},
  messageRef: D,
  name: P,
  onBlur: T,
  onChange: h,
  onFocus: w,
  placeholder: M,
  prefix: j,
  secondaryLabel: s,
  size: L,
  suffix: $,
  supplemental: x,
  tone: I,
  type: b,
  textarea: _ = !1,
  value: V,
  ...Z
}, oe) {
  const te = Ce(), ae = p.id || `label-${te}`, fe = `description-${te}`, se = i || `input-${te}`, O = k.id || `message-${te}`;
  let pe = null;
  v && (pe = /* @__PURE__ */ d.jsxs("div", { children: [
    /* @__PURE__ */ d.jsx(
      ut,
      {
        ...p,
        block: !0,
        className: m,
        id: ae,
        ref: y,
        htmlFor: se,
        secondaryLabel: n ? void 0 : s,
        children: v
      }
    ),
    typeof n < "u" && /* @__PURE__ */ d.jsx(ct, { id: fe, children: n })
  ] }));
  let ce;
  (C || n) && (ce = [n && fe, C && O].filter(Boolean).join(" "));
  const ue = {
    "aria-describedby": ce,
    "aria-labelledby": v ? ae : void 0,
    block: e,
    className: F(vn.textfield__input, u),
    defaultValue: r,
    disabled: a,
    id: se,
    invalid: I === "critical",
    name: P,
    placeholder: M,
    type: b,
    value: V
  };
  let ve = _ ? /* @__PURE__ */ d.jsx(
    eu,
    {
      ...c,
      ...ue,
      onBlur: T,
      onChange: h,
      onFocus: w,
      ref: f
    }
  ) : /* @__PURE__ */ d.jsx(
    To,
    {
      ...c,
      ...ue,
      onBlur: T,
      onChange: h,
      onFocus: w,
      ref: f,
      size: L
    }
  );
  ($ || j) && (ve = /* @__PURE__ */ d.jsxs(Co, { disabled: a, block: e, children: [
    j && /* @__PURE__ */ d.jsx(zr, { htmlFor: se, children: j }),
    ve,
    $ && /* @__PURE__ */ d.jsx(zr, { htmlFor: se, children: $ })
  ] }));
  let Pe = null;
  return C && (Pe = /* @__PURE__ */ d.jsx(
    Ft,
    {
      ...k,
      className: S,
      id: O,
      ref: D,
      tone: I,
      children: C
    }
  )), /* @__PURE__ */ d.jsxs(
    Ze,
    {
      ...Z,
      direction: "column",
      gap: "0.5rem",
      className: F(e && vn["textfield--block"], t),
      ref: oe ?? o,
      children: [
        pe,
        x,
        ve,
        Pe
      ]
    }
  );
}
const Iu = /* @__PURE__ */ z(
  ru
);
export {
  su as Accordion,
  Gi as AccordionContent,
  tl as AccordionItem,
  nl as AccordionRoot,
  il as AccordionTrigger,
  Du as Base,
  cu as Button,
  du as ButtonLink,
  fu as Callout,
  Fu as Caption,
  bu as Checkbox,
  gu as CheckboxGroup,
  hu as Collapsible,
  ho as CollapsibleContent,
  co as CollapsibleRoot,
  fo as CollapsibleTrigger,
  pu as DeprecatedFeedbackCallout,
  ct as Description,
  Eu as Display,
  _u as ExclamationSpinner,
  ju as Fineprint,
  Ze as Flex,
  mu as Grid,
  Su as H1,
  Tu as H2,
  Cu as H3,
  To as Input,
  Co as InputGroup,
  zr as InputGroupLabel,
  ut as Label,
  ku as Lead,
  uu as Link,
  Ft as Message,
  $u as NumericStepper,
  Lu as Paragraph,
  wu as Prose,
  yu as Radio,
  xu as RadioGroup,
  kc as Select,
  Pu as SelectField,
  vu as Spacer,
  dl as Spinner,
  Er as Switch,
  pi as SwitchLabel,
  fi as SwitchRoot,
  bi as SwitchThumb,
  Jc as Text,
  Iu as TextField,
  eu as Textarea,
  Nc as VisuallyHidden,
  F as cx
};
//# sourceMappingURL=index.es.js.map
